<template>
  <div class="container">
    <AllShowConfirm
      :text="$t('是否访问全部模型，若模型太大可能出现加载失败的情况')"
      v-show="showAllConfirm"
      @cancel="handleAllShowCancel"
      @confirm="handleAllShowConfirm"
    ></AllShowConfirm>

    <div class="title">
      <div>
        <div class="h2">{{ gltfFile.name }}</div>
        <div class="file-size">{{ $t('文件大小') }}：{{ gltfFile.size }}MB</div>
      </div>
      <div class="lang">
        <span
          :class="{ 'text-blue': currentLocale === 'cn' }"
          @click="changeLocale('cn')"
          >中文</span
        >
        &nbsp;|&nbsp;
        <span
          :class="{ 'text-blue': currentLocale === 'en' }"
          @click="changeLocale('en')"
          >English</span
        >
      </div>
    </div>

    <div
      class="graphy"
      v-loading="opacityMeshLoading"
      :element-loading-text="$t('加载中')"
    >
      <div id="gltf-container">
        <div class="loading-mask" v-show="loadingPercent < 100">
          <div class="progress-content">
            <div v-if="isPart" style="color: #409eff; text-align: center">
              <i class="el-icon-loading"></i>
              {{ partLoadingText }}
            </div>

            <el-progress
              :percentage="loadingPercent"
              :format="progressFormatter"
              v-else
            ></el-progress>
          </div>
        </div>
      </div>
      <div class="mesh-loading" v-show="meshLoadingProgress < 100">
        <el-progress
          :text-inside="true"
          :stroke-width="14"
          :percentage="meshLoadingProgress"
          status="success"
        ></el-progress>
      </div>
      <div
        class="handle-area"
        v-show="handleShow && meshLoadingProgress >= 100"
      >
        <div
          class="item"
          :class="{
            active: item.operateType === activeHandle,
            'item-label': !item.children,
          }"
          :data-text="item.label"
          v-for="(item, index) in handleItems"
          :key="index"
          v-show="typeof item.show !== 'boolean' || item.show"
          @click="handleOperate(item.operateType)"
        >
          <svgIcon
            :name="item.icon"
            :scale="1"
            class="svg-icon item-svg-icon"
          />

          <div class="children" v-if="item.children && item.children.length">
            <div
              v-for="(chlid, key) in item.children"
              :key="key"
              @click.stop="handleOperate(item.operateType, chlid.operateType)"
            >
              <svgIcon
                :name="chlid.icon"
                :scale="1"
                class="svg-icon child-svg-icon"
                :class="{ 'child-active': chlid.operateType === handleChild }"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="show-all" v-show="showAll">
        <el-button @click="showAllHandler">{{ $t('显示全部') }}</el-button>
      </div>
      <div class="out-mesh-clipping" v-show="showMeshClipping">
        <el-button @click="showMeshClippingHandler">{{
          $t('退出构件剖切')
        }}</el-button>
      </div>
      <div class="origin-pointer" v-show="originPointerShow">
        <div class="c1">
          <div class="c2"></div>
        </div>
      </div>
      <div
        class="reset-scene"
        :class="{ is_mobile: isMobile }"
        @click="resetScene"
      >
        <i class="el-icon-s-home"></i>
      </div>
      <div v-if="isMobile">
        <van-popup
          v-model="treeShow"
          position="center"
          :style="{ height: '100%', width: '100%' }"
          closeable
          :overlay="false"
          :duration="0.1"
          class="mobile-tree-popup"
        >
          <div class="popup-content">
            <h3>{{ $t('结构树') }}</h3>
            <el-tree
              ref="tree"
              class="mobile-tree"
              :data="nodeTree"
              node-key="value"
              :props="defaultProps"
              :filter-node-method="filterNode"
              :default-checked-keys="defaultCheckedKeys"
              show-checkbox
              highlight-current
              @check="onNodeCheckChange"
              @node-click="onNodeClick"
              lazy
              :load="loadNode"
            >
            </el-tree>
          </div>
        </van-popup>
        <van-popup
          v-model="attrShow"
          position="center"
          :style="{ height: '100%', width: '100%' }"
          closeable
          :overlay="false"
          :duration="0.1"
        >
          <div class="popup-content">
            <h3>{{ $t('构件信息') }}</h3>
            <div v-if="properties" class="info">
              <div v-for="(value, key) in properties" :key="key">
                <h4>
                  {{ key }}
                </h4>
                <div
                  v-for="(cval, ckey) in value"
                  :key="ckey"
                  class="info-item"
                >
                  <span style="padding-left: 12px">{{ ckey }}: </span>
                  <span style="color: #444">{{ cval }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-popup>
        <van-popup
          v-model="searchOps.show"
          position="center"
          :style="{ height: '100%', width: '100%' }"
          closeable
          :overlay="false"
          :duration="0.1"
        >
          <div class="popup-content">
            <h3>{{ $t('属性搜索') }}</h3>
            <div class="search-area">
              <div class="row" @keyup.enter="searchHandle">
                <div class="row-label">{{ $t('属性值') }}:</div>
                <el-input
                  size="mini"
                  v-model.trim="searchOps.key"
                  :placeholder="$t('选填，全词匹配且区分大小写')"
                ></el-input>
              </div>
              <div class="row" @keyup.enter="searchHandle">
                <div class="row-label">{{ $t('属性值') }}:</div>
                <el-input
                  size="mini"
                  v-model.trim="searchOps.value"
                  :placeholder="$t('必填')"
                ></el-input>
              </div>
              <div class="handle">
                <div class="item">
                  <el-checkbox
                    @change="searchAllHandler"
                    :disabled="searchOps.list.length === 0"
                    >{{ $t('选择所有') }}
                  </el-checkbox>
                </div>
                <div class="item">
                  <el-checkbox v-model="searchOps.wholeWords"
                    >{{ $t('全词匹配') }}
                  </el-checkbox>
                </div>
                <div class="item">
                  <el-checkbox v-model="searchOps.lowcase"
                    >{{ $t('区分大小写') }}
                  </el-checkbox>
                </div>
                <div>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="searchHandle"
                    :loading="searchLoading"
                    >{{ $t('搜索') }}
                  </el-button>
                </div>
              </div>
              <div
                style="
                  height: calc(100vh - 300px);
                  overflow-y: auto;
                  margin-bottom: 60px;
                "
                ref="scrollContainer"
                @scroll="handleScrollContainer"
              >
                <div
                  class="list-item"
                  v-for="(item, index) in searchOps.list"
                  :key="index"
                >
                  <el-checkbox
                    v-model="item.checked"
                    @change="searchItemHandler(item.checked)"
                  ></el-checkbox>
                  <span
                    class="label"
                    @click="
                      item.checked = !item.checked;
                      searchItemHandler(item.checked);
                    "
                  >
                    {{ item.key }}：{{ item.value }}</span
                  >
                </div>
                <div style="text-align: center; color: #666; line-height: 88px">
                  {{ searchMsg }}
                </div>
              </div>
            </div>
          </div>
        </van-popup>
        <div class="roam-mobile" v-show="roamShow">
          <div class="position">
            <div class="row">
              <div class="item" @click="manualRoam('up')">
                <svgIcon name="pull_up" :scale="1" class="svg-icon" />
              </div>
            </div>
            <div class="row">
              <div class="item" @click="manualRoam('left')">
                <svgIcon name="pull_left" :scale="1" class="svg-icon" />
              </div>
              <div class="item" @click="manualRoam('down')">
                <svgIcon name="pull_down" :scale="1" class="svg-icon" />
              </div>
              <div class="item" @click="manualRoam('right')">
                <svgIcon name="pull_right" :scale="1" class="svg-icon" />
              </div>
            </div>
          </div>
          <div class="pan-rate">
            <p>{{ $t('移动速度') }}：</p>
            <el-input-number
              v-model="panRate"
              :min="1"
              :max="10"
              :precision="0"
            ></el-input-number>
            <span
              class="cls-btn"
              @click="
                handleShow = true;
                roamShow = false;
              "
              ><i class="el-icon-circle-close"></i
            ></span>
          </div>
        </div>
        <div class="mobile-clipping" v-show="mobileClipping">
          <div class="site" @click="mobileClippingSiteChange()">
            {{ mobileClippingSite }}
          </div>
          <div class="slider" v-show="mobileClippingSite === 'x'">
            <el-slider
              v-model="mobileClippingValueX"
              :min="mobileClippingMin.x"
              :max="mobileClippingMax.x"
              :show-tooltip="false"
              @input="(val) => mobileClippingInput(val, 'x')"
              range
            ></el-slider>
          </div>
          <div class="slider" v-show="mobileClippingSite === 'y'">
            <el-slider
              v-model="mobileClippingValueY"
              :min="mobileClippingMin.y"
              :max="mobileClippingMax.y"
              :show-tooltip="false"
              @input="(val) => mobileClippingInput(val, 'y')"
              range
            ></el-slider>
          </div>
          <div class="slider" v-show="mobileClippingSite === 'z'">
            <el-slider
              v-model="mobileClippingValueZ"
              :min="mobileClippingMin.z"
              :max="mobileClippingMax.z"
              :show-tooltip="false"
              @input="(val) => mobileClippingInput(val, 'z')"
              range
            ></el-slider>
          </div>
          <div class="close" @click="handleOperate('outclipping')">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <div v-else>
        <el-card
          class="tree-card"
          :body-style="{ height: 'calc(100vh - 240px)', marginBottom: '15px' }"
          v-show="treeShow"
          v-cardDrag
        >
          <div slot="header" class="clearfix">
            <span>{{ $t('结构') }}</span>
            <span
              style="float: right; margin-top: 3px; cursor: pointer"
              @click="
                () => {
                  treeShow = false;
                  this.activeHandle = null;
                }
              "
              ><i class="el-icon-close"></i
            ></span>
          </div>
          <el-input
            :placeholder="$t('输入关键字搜索')"
            size="mini"
            v-model="treeFilter"
            clearable
          ></el-input>
          <vue-scroll :ops="{ bar: { background: '#f4f4f4' } }">
            <el-tree
              ref="tree"
              :data="nodeTree"
              node-key="value"
              :props="defaultProps"
              :filter-node-method="filterNode"
              :default-checked-keys="defaultCheckedKeys"
              show-checkbox
              highlight-current
              @check="onNodeCheckChange"
              @node-click="onNodeClick"
              lazy
              :load="loadNode"
            >
            </el-tree>
          </vue-scroll>
        </el-card>
        <el-card
          class="tree-card info"
          :body-style="{ height: 'calc(100vh - 240px)', marginBottom: '15px' }"
          v-show="attrShow"
          v-cardDrag
        >
          <div slot="header" class="clearfix">
            <span>{{ $t('构件信息') }}</span>
            <span
              style="float: right; margin-top: 3px; cursor: pointer"
              @click="
                () => {
                  attrShow = false;
                  this.activeHandle = null;
                }
              "
              ><i class="el-icon-close"></i
            ></span>
          </div>
          <vue-scroll :ops="{ bar: { background: '#f4f4f4' } }">
            <div v-if="properties">
              <div v-for="(value, key) in properties" :key="key">
                <h4>
                  {{ key }}
                </h4>
                <div
                  v-for="(cval, ckey) in value"
                  :key="ckey"
                  class="info-item"
                >
                  <span style="padding-left: 12px">{{ ckey }}: </span>
                  <span style="color: #444">{{ cval }}</span>
                </div>
              </div>
            </div>
          </vue-scroll>
        </el-card>
        <el-card
          class="search-card"
          :body-style="{
            display: 'flex',
            flexDirection: 'column',
          }"
          v-show="searchOps.show"
          v-cardDrag
        >
          <div slot="header" class="clearfix">
            <span>{{ $t('属性搜索') }}</span>
            <span
              style="float: right; margin-top: 3px; cursor: pointer"
              @click="searchOps.show = false"
              ><i class="el-icon-close"></i
            ></span>
          </div>
          <div class="search-area">
            <div class="row" @keyup.enter="searchHandle">
              <div class="row-label">{{ $t('属性名') }}:</div>
              <el-input
                size="mini"
                v-model.trim="searchOps.key"
                :placeholder="$t('选填，全词匹配且区分大小写')"
              ></el-input>
            </div>
            <div class="row" @keyup.enter="searchHandle">
              <div class="row-label">{{ $t('属性值') }}:</div>
              <el-input
                size="mini"
                v-model.trim="searchOps.value"
                :placeholder="$t('必填')"
              ></el-input>
            </div>
            <div class="handle">
              <div class="item">
                <el-checkbox
                  v-model="checkedAllValue"
                  @change="searchAllHandler"
                  :disabled="searchOps.list.length === 0"
                  >{{ $t('选择所有') }}
                </el-checkbox>
              </div>
              <div class="item">
                <el-checkbox v-model="searchOps.wholeWords"
                  >{{ $t('全词匹配') }}
                </el-checkbox>
              </div>
              <div class="item">
                <el-checkbox v-model="searchOps.lowcase"
                  >{{ $t('区分大小写') }}
                </el-checkbox>
              </div>
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  @click="searchHandle"
                  :loading="searchLoading"
                  >{{ $t('搜索') }}
                </el-button>
              </div>
            </div>
            <div
              class="scroll-container"
              ref="scrollContainer"
              @scroll="handleScrollContainer"
            >
              <div
                class="list-item"
                v-for="(item, index) in searchOps.list"
                :key="index"
              >
                <el-checkbox
                  v-model="item.checked"
                  @change="searchItemHandler"
                ></el-checkbox>
                <span
                  class="label"
                  @click="
                    item.checked = !item.checked;
                    searchItemHandler(item.checked);
                  "
                >
                  {{ item.key }}：{{ item.value }}</span
                >
              </div>
              <div style="text-align: center; color: #666; line-height: 88px">
                {{ searchMsg }}
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="roam-tip" v-show="roamTipShow">
          <div style="text-align: center">
            <h4>{{ $t('漫游操作说明') }}</h4>
          </div>
          <div>
            <!-- <img :src="roamTip" /> -->
            <div style="display: flex; align-items: center">
              <div class="wasd">
                <span style="font-size: 18px; font-weight: bold">{{
                  $t('前后左右')
                }}</span>
                <img :src="wasd" />
              </div>
              <div style="font-size: 18px; font-weight: bold; min-width: 60px">
                {{ $t('或者') }}
              </div>
              <div class="updownrightleft">
                <img :src="updownrightleft" />
              </div>
            </div>
            <div
              style="width: 100%; height: 2px; background-color: #ececec"
            ></div>
            <div style="display: flex; align-items: center">
              <div class="qe">
                <span style="font-size: 18px; font-weight: bold">{{
                  $t('向上或者向下')
                }}</span
                ><img :src="qe" />
              </div>
              <div class="ad">
                <span style="font-size: 18px; font-weight: bold">{{
                  $t('调整速度')
                }}</span>
                <img :src="ad" />
              </div>
            </div>
          </div>
          <div style="line-height: 60px; text-align: center">
            <el-button size="small" type="success" @click="roamTipShow = false"
              >{{ $t('我知道了') }}~
            </el-button>
          </div>
        </el-card>
        <el-card
          class="clipping-card"
          :body-style="{ height: 'calc(54vh - 240px)', marginBottom: '15px' }"
          v-if="clippingShow"
          v-cardDrag
        >
          <div slot="header" class="clearfix">
            <span>{{ $t('剖切') }}</span>
            <span
              style="float: right; margin-top: 3px; cursor: pointer"
              @click="clippingPanelClose"
              ><i class="el-icon-close"></i
            ></span>
          </div>
          <div class="clipping-control">
            <div class="clipping-control-title colorx">X</div>
            <div class="clipping-control-item x">
              <div class="l">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('x')"
                  v-model="xLeftValue"
                ></el-input-number>
              </div>
              <el-slider
                class="slider"
                v-model="clippingValueX"
                range
                :min="-1000"
                :max="1000"
                :show-tooltip="false"
                @input="(value) => clippingSlider(value, 'x')"
              ></el-slider>
              <div class="r">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('x')"
                  v-model="xRightValue"
                  type="number"
                ></el-input-number>
              </div>
            </div>
            <div class="clipping-control-title colory">Y</div>
            <div class="clipping-control-item y">
              <div class="l">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('y')"
                  v-model="yDownValue"
                ></el-input-number>
              </div>
              <el-slider
                class="slider"
                v-model="clippingValueY"
                range
                :min="-1000"
                :max="1000"
                :show-tooltip="false"
                @input="(value) => clippingSlider(value, 'y')"
              ></el-slider>
              <div class="r">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('y')"
                  v-model="yUpValue"
                ></el-input-number>
              </div>
            </div>
            <div class="clipping-control-title colorz">Z</div>
            <div class="clipping-control-item z">
              <div class="l">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('z')"
                  v-model="zBackValue"
                ></el-input-number>
              </div>
              <el-slider
                class="slider"
                v-model="clippingValueZ"
                range
                :min="-1000"
                :max="1000"
                :show-tooltip="false"
                @input="(value) => clippingSlider(value, 'z')"
              ></el-slider>
              <div class="r">
                <el-input-number
                  :controls="false"
                  :min="-100"
                  :max="100"
                  @change="(cur, old) => clippingInput('z')"
                  v-model="zFrontValue"
                ></el-input-number>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="flex-center">
            <el-button type="button" size="small" @click="resetSectionBox()"
              >{{ $t('恢复默认') }}
            </el-button>
          </div>
        </el-card>
        <div class="roam-container" v-show="roamShow">
          <span>{{ $t('移动速度') }}：</span>
          <el-input-number
            v-model="panRate"
            :min="1"
            :max="10"
            :precision="0"
          ></el-input-number>
          <span
            class="cls-btn"
            @click="
              handleShow = true;
              roamShow = false;
              activeHandle = null;
            "
            ><i class="el-icon-circle-close"></i
          ></span>
        </div>
      </div>
      <div class="pit-icon" v-show="pitShow">
        <svgIcon name="cross" :scale="1" class="svg-icon" />
      </div>
    </div>
        <div
      class="watermark-mask"
      :style="{ backgroundImage: `url(${watermarkImage})` }"
    ></div>
  </div>
</template>
<script>
import TWEEN from '@tweenjs/tween.js';
import * as THREE from 'three';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min';
import { GLTFLoader } from './js/GLTFLoader';
import { OrbitControls } from './js/OrbitControls';
import { OrientationHelper } from './js/OrientationHelper.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import {
  CSS2DRenderer,
  CSS2DObject,
} from 'three/examples/jsm/renderers/CSS2DRenderer';

import { Data } from 'js/class/Data';
import axios from 'axios';
import deepClone from 'lodash.clonedeep';
import { checkDeci, getUrlStringQueryParam, isMobile } from '@/utils/common.js';

import roamTip from 'assets/imgs/roam-tip.png';

import wasd from 'assets/imgs/wasd.png';
import updownrightleft from 'assets/imgs/updownrightleft.png';
import qe from 'assets/imgs/qe.png';
import ad from 'assets/imgs/ad.png';

import AllShowConfirm from './components/AllShowConfirm.vue';

const requestUrl = 'https://bim.geto.pro';
// const requestUrl = 'http://192.168.65.18:8585';

let oldMaterials = {};
let meshes = [];
let instanceMeshes = {};
let hideInstanceMeshes = {};

let group;
let gui;
let ambientLight;
let raycaster = new THREE.Raycaster();

let camera = null,
  cameraSize;
let scene = null;
let renderer = null;
let labelRenderer = null;
let controls = null;
let lastClickTime = Date.now();
let renderRequested = false;
let pmremGenerator = null;
let originalCamera = null;
let propertiesJson = null;
let measureStart = true;
let measurePoints = [];
let lastEdgePoint = null;
let bottomPlane = null;
let viewScale = null;
let measureLengthStart = false;
let measureHeightStart = false;

let defaultCheckedKeys = [];
let fileLoadedSize = 0;

let oldRayObj = null;

let moveLineGeometry = new THREE.BufferGeometry();
moveLineGeometry.setDrawRange(0, 2);
moveLineGeometry.instanceCount = 0;
const positions = new Float32Array(20 * 3); // 3 vertices per point
moveLineGeometry.setAttribute(
  'position',
  new THREE.BufferAttribute(positions, 3)
);
let moveLine = null;

let originalRadius = null; // 漫游时向上或向下时step步长会随着之后的半径而变化

let boxMax, boxMin, groupBox, boxGroup;
let faces, activeFace;
let lines;
let planes, vertices;
let scale = false;

let drag = {
  axis: '',
  point: new THREE.Vector3(),
  ground: new THREE.Mesh(
    new THREE.PlaneGeometry(1000000, 1000000),
    new THREE.MeshBasicMaterial({ colorWrite: false, depthWrite: false })
  ),
};

const defaultFile = localStorage.getItem('defaultFile') || 'gltfFineUrl';

let helperBox = new THREE.Box3(); // 辅助box 用于计算模型中心点

export default {
  name: 'App',
  components: {
    AllShowConfirm,
  },
  data() {
    return {
      modelId: '',
      modelCode: '',
      partLoadingText: '获取模型文件中...',
      handleShow: true,
      checkedAllValue: false,
      isPart: false,
      isMobile: false,
      showAllConfirm: false,
      searchPage: 1,
      searchSize: 100,
      nodeTreeHideMeshesUuid: {},
      handleChild: '',
      showMeshClipping: false,
      clickPoint: null,
      mobileClippingSite: 'x',
      mobileClippingMin: {
        x: 0,
        y: 0,
        z: 0,
      },
      mobileClippingMax: {
        x: 0,
        y: 0,
        z: 0,
      },
      mobileClippingValueX: [0, 0],
      mobileClippingValueY: [0, 0],
      mobileClippingValueZ: [0, 0],
      mobileClipping: false,
      yUpValue: 100,
      yDownValue: -100,
      xLeftValue: -100,
      xRightValue: 100,
      zFrontValue: 100,
      zBackValue: -100,
      clippingValueX: [-1000, 1000],
      clippingValueY: [-1000, 1000],
      clippingValueZ: [-1000, 1000],
      opacityMeshLoading: false,
      meshLoadingProgress: 0,
      searchLoading: false,
      searchMsg: '（' + this.$t('空') + '）',
      searchHandleLoading: false,
      hideValue: '',
      roamTip: roamTip,
      wasd,
      updownrightleft,
      qe,
      ad,
      gltfFile: {
        name: '',
        size: '',
      },
      treeFilter: '',
      defaultCheckedKeys: [],
      nodeTree: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      clickMaterial: {
        name: '',
        size: '',
      },
      properties: null,
      handleShow: true,
      handleItems: [
        {
          label: this.$t('名称切换'),
          icon: 'switch',
          operateType: 'switch',
        },
        {
          label: this.$t('属性'),
          icon: 'attr',
          operateType: 'attr',
        },
        {
          label: this.$t('结构树'),
          icon: 'tree',
          operateType: 'tree',
        },
        {
          label: this.$t('完整显示'),
          icon: 'all',
          operateType: 'all',
          show: false,
        },
        {
          label: this.$t('测量'),
          icon: 'measure',
          operateType: 'measure',
        },
        {
          label: this.$t('搜索'),
          icon: 'search',
          operateType: 'search',
        },
        {
          label: this.$t('漫游'),
          icon: 'move',
          operateType: 'move',
        },
        {
          label: this.$t('全屏'),
          icon: 'fullscreen',
          operateType: 'fullscreen',
          show: true,
        },
        {
          label: this.$t('退出全屏'),
          icon: 'notfull',
          operateType: 'fullscreen',
          show: false,
        },
        {
          label: this.$t('剖切'),
          icon: 'model',
          operateType: 'clippingItem',
          show: true,
          children: [
            {
              label: this.$t('剖切'),
              icon: 'clipping',
              operateType: 'clipping',
              show: true,
            },
            {
              label: '构件剖切',
              icon: 'meshClipping',
              operateType: 'meshClipping',
              show: true,
            },
          ],
        },
      ],
      activeHandle: '',
      measureItems: [
        {
          label: this.$t('长度'),
          icon: 'measure_width',
          operateType: 'measure_width',
        },
        {
          label: this.$t('标高'),
          icon: 'measure_height',
          operateType: 'measure_height',
        },
        {
          label: this.$t('关闭测量'),
          icon: 'close',
          operateType: 'measure_close',
        },
      ],
      treeShow: false,
      attrShow: false,
      clippingShow: false,
      searchOps: {
        show: false,
        key: '',
        value: '',
        wholeWords: false,
        lowcase: false,
        list: [],
      },
      showAll: false,
      originPointerShow: false,
      isFullscreen: false,
      panRate: 1,
      // keyPanSpeed: 7,
      roamShow: false,
      roamTipShow: false,
      loadingPercent: 0,
      pitShow: false,
      meshesUniqueId: {},
      currentLocale: 'zh',
      watermarkImage: '',
    };
  },
  computed: {
    keyPanSpeed() {
      return 7 * (this.panRate || 1);
    },
  },
  watch: {
    treeFilter(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.currentLocale = this.$i18n.locale;
    
    this.modelId = this.getQueryString('id');

    const codeNew = this.getQueryString('code');
    this.modelCode = codeNew ? decodeURIComponent(codeNew) : '';

    this.isPart = !!this.modelCode;
    this.isMobile = isMobile();
  },
  async mounted() {
        this.generateWatermark('/img/logoimage2.png');
    let handleItem = this.handleItems.find((e) => e.operateType === 'switch');
    handleItem.label =
      defaultFile === 'gltfFineUrl'
        ? this.$t('显示拼装编号')
        : this.$t('显示物料名称');

    this.isMobile &&
      this.handleItems.forEach((e) => {
        if (['fullscreen', 'move'].includes(e.icon)) {
          e.show = false;
        }
      });

    const elId = 'gltf-container';
    this.el = document.getElementById(elId);

    this.initRenderer();
    this.initScene();
    this.initCamera();

    if (camera && labelRenderer) {
      this.initControls(camera, labelRenderer);
    }

    group = new THREE.Group({ name: 'group' });
    const filePath = await this.getFilePath();

    this.gltfFile = {
      name: filePath.rvtName,
      size: (filePath.rvtSize / 1024 / 1024).toFixed(2),
    };

    if (this.isPart) {
      this.partLoadingText = this.$t('渲染模型中') + '...';
      const closeOperateTypes = ['tree', 'clippingItem', 'attr', 'search'];
      // 存在code 结构树隐藏
      this.handleItems.forEach((item) => {
        if (closeOperateTypes.includes(item.operateType)) {
          item.show = false;
        }
        if (item.operateType === 'all') {
          item.show = true;
        }
      });
      const jsonLoader = await this.getMeshCache();
      if (jsonLoader.code == 200) {
        let loader = new THREE.ObjectLoader();
        group = loader.parse(JSON.parse(jsonLoader.cache.cache));

        let focusMesh = null;
        const boxCenter = JSON.parse(jsonLoader.cache.box_center);
        meshes = group.children;

        meshes.forEach((mesh) => {
          mesh.isText = mesh.material.name.indexOf('字') > 0;
          // 文字模型不处理
          if (!mesh.isText) {
            const geometry = mesh.geometry.clone();
            const matrix = mesh.matrix.clone();
            const { code } = mesh.userData;
            if (code === this.modelCode) {
              mesh.material.color.copy(new THREE.Color(0x42ff6e));
              this.createbaseMesh(
                group,
                mesh.material.clone(),
                geometry,
                matrix,
                'currentMesh'
              );
              this.createHighLine(geometry, matrix);

              focusMesh = mesh;
            }

            mesh.material.transparent = true;
            mesh.material.opacity = 0.3;
            mesh.material.color.copy(new THREE.Color(0x999999));

            this.createLineSegments(geometry, matrix, 'stroke_line');
          }

          this.meshesUniqueId[mesh.userData.UniqueId] = {
            uuid: mesh.uuid,
            mesh: mesh,
          };
        });

        this.meshLoadingProgress = 100;

        helperBox = new THREE.Box3().setFromObject(group);
        scale = group.children[0].scale.clone();

        this.setContent(group, boxCenter.cameraSize, boxCenter.groupPostion);

        this.el.addEventListener('click', this.onCacheMaterialClick);
        this.updateEnvironment();
        this.resizeRegister();

        const position = new THREE.Vector3();
        position.setFromMatrixPosition(focusMesh.matrixWorld);
        camera.position.set(-position.x, -position.y, -position.z + 300);

        this.setControlsTarget(focusMesh);

        this.render();
      } else {
        this.initMeshes(filePath, this.modelCode);
      }
    } else {
      this.initMeshes(filePath);
    }

    this.setLight();
    // this.buildGui();
  },
  methods: {
        generateWatermark(imgSrc = '/img/logoimage2.png') {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        // 按原始等比例限制最大宽度
        const maxWidth = 180;
        const ratio = img.width > maxWidth ? maxWidth / img.width : 1;
        const targetWidth = img.width * ratio;
        const targetHeight = img.height * ratio;

        const canvas = document.createElement('canvas');
        const width = 300;
        const height = 200;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.translate(width / 2, height / 2);
        ctx.rotate((-20 * Math.PI) / 180);
        ctx.globalAlpha = 0.25;
        ctx.drawImage(img, -targetWidth / 2, -targetHeight / 2, targetWidth, targetHeight);
        ctx.restore();
        this.watermarkImage = canvas.toDataURL('image/png');
      };
      img.onerror = () => {
        // 图片加载失败时回退到文字水印
        this.generateWatermarkText('GETO');
      };
      img.src = imgSrc;
    },
    generateWatermarkText(text = 'GETO') {
      const canvas = document.createElement('canvas');
      const width = 300;
      const height = 200;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.rotate((-20 * Math.PI) / 180);
      ctx.font = '18px "Microsoft YaHei", Arial, sans-serif';
      ctx.fillStyle = 'rgba(180, 180, 180, 0.25)';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, 20, height / 2);
      this.watermarkImage = canvas.toDataURL('image/png');
    },
    changeLocale(locale) {
      localStorage.setItem('locale', locale);

      this.$i18n.locale = locale;

      location.reload();
    },
    createHighLine(geometry, matrix, name = 'highlight_line') {
      const edges = new THREE.EdgesGeometry(geometry);
      const line = new THREE.LineSegments(
        edges,
        new THREE.LineBasicMaterial({
          color: 0x42ff6e,
          linewidth: window.devicePixelRatio,
        })
      );
      line.applyMatrix4(matrix);
      line.material.depthTest = false;
      line.name = name;
      group.add(line);
      this.render();

      return line;
    },
    createLineSegments(geometry, matrix, name) {
      const edges = new THREE.EdgesGeometry(geometry);
      const line = new THREE.LineSegments(
        edges,
        new THREE.LineBasicMaterial({
          color: 0xdfe0df,
          linewidth: 0.1,
        })
      );
      line.applyMatrix4(matrix);
      line.name = name;
      group.add(line);
      this.render();
    },
    setControlsTarget(mesh) {
      const box = new THREE.Box3().setFromObject(mesh);
      const center = new THREE.Vector3();
      box.getCenter(center);
      this.animateControls(center);
    },
    createbaseMesh(group, material, geometry, matrix, name) {
      const mesh = new THREE.Mesh(geometry, material);
      mesh.applyMatrix4(matrix);
      // mesh.material.depthTest = false;
      mesh.name = name;
      group.add(mesh);
      this.render();
    },
    deletebaseMesh(name) {
      const nameArr = Array.isArray(name) ? name : [name];
      const children = group.children;
      for (let i = children.length - 1; i >= 0; i--) {
        if (nameArr.includes(children[i].name)) {
          group.remove(children[i]);
        }
      }
      this.render();
    },
    findObjWithPoint(clientX, clientY) {
      let mouse = new THREE.Vector2();
      const container = this.el;
      const getBoundingClientRect = container.getBoundingClientRect();
      mouse.x =
        ((clientX - getBoundingClientRect.left) / container.offsetWidth) * 2 -
        1;
      mouse.y =
        -((clientY - getBoundingClientRect.top) / container.offsetHeight) * 2 +
        1;
      raycaster.setFromCamera(mouse, camera);
      const intersects = raycaster.intersectObjects(meshes) || [];
      return intersects.length > 0 ? intersects[0] : null;
    },
    onCacheMaterialClick(target) {
      if (!target || !this.tapStartTimestmap) return;
      if (
        target.timeStamp - this.tapStartTimestmap > 500 ||
        target.button !== 0
      ) {
        return;
      }
      target.preventDefault();
      const rayObj = this.findObjWithPoint(target.clientX, target.clientY);
      if (rayObj) {
        const mesh = rayObj.object;
        if (measureStart) {
          // 测量点击
          this.modelMeasurementClick(rayObj.point);
        }
        if (mesh.type !== 'Mesh' || mesh.isText) return;

        this.setControlsTarget(mesh);
        this.deletebaseMesh(['currentMesh', 'highlight_line']);

        const material = mesh.material.clone();
        material.opacity = 1;
        material.color.copy(new THREE.Color(0x42ff6e));

        const geometry = mesh.geometry.clone();
        const matrix = mesh.matrix.clone();
        this.createbaseMesh(group, material, geometry, matrix, 'currentMesh');
        this.createHighLine(geometry, matrix);
      }
    },
    modelMeasurementClick(point) {
      if (measureHeightStart) {
        this.distanceToBottom(point);
        return;
      }
      if (measureLengthStart) {
        // 存在边缘点
        if (lastEdgePoint) {
          point = this.findObjWithPoint(lastEdgePoint.x, lastEdgePoint.y).point;
        }
        this.createPoint(point);
        measurePoints.push(point);
        if (measurePoints.length === 2) {
          this.createLine(measurePoints);
          measurePoints = [];
          if (moveLine) {
            this.removeLine(/move_line/);
            moveLine = null;
          }
        } else if (measurePoints.length === 1) {
          this.removeLine(/helper_line/);
        }
        return;
      }
    },
    handleScrollContainer(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (
        this.isScrolling &&
        this.searchLoading === false &&
        scrollTop + clientHeight === scrollHeight
      ) {
        this.searchPage += 1;
        this.searchHandleRequest();
      }
    },
    loadNode(node, resolve) {
      if (node.level !== 0 && node.data) {
        resolve(node.data.children);
        node.childNodes.forEach((item) => {
          if (!item.data.children || !item.data.children.length)
            item.isLeaf = true;
        });
      } else if (node.level === 0 && this.isMobile) {
        resolve(node.data);
      }
    },
    buildGui() {
      gui = new GUI();
    },
    async handleOperate(operateType, childType, mesh) {
      this.activeHandle = operateType;
      switch (operateType) {
        case 'attr':
          if (this.properties) {
            this.attrShow = true;
          }
          break;
        case 'tree':
          this.treeShow = true;
          break;
        case 'search':
          this.searchOps.show = true;
          break;
        case 'fullscreen':
          this.fullscreenHandler();
          break;
        case 'move':
          this.roamShow = true;
          this.roamTipShow = true;
          this.handleShow = false;
          break;
        case 'measure':
          this.handleItemsOrigin = this.handleItems;
          this.handleItems = this.measureItems;
          measureLengthStart = true;
          !this.isMobile && controls.registerMousemove();
          break;
        case 'measure_close':
          this.measureClose();
          controls.unregisterMousemove();
          break;
        case 'measure_width':
          measureLengthStart = true;
          measureHeightStart = false;
          !this.isMobile && controls.registerMousemove();
          break;
        case 'measure_height':
          measureLengthStart = false;
          measureHeightStart = true;
          controls.unregisterMousemove();
          break;
        case 'clippingItem':
          this.handleChild = childType;
          if (childType === 'clipping') {
            this.handleShow = false;
            this.el.removeEventListener('click', this.onMaterialClick);
            this.isClipping = true;
            this.showMeshClipping = false;
            this.enableClipping(mesh);
            if (this.isMobile) {
              this.mobileClipping = true;
            } else {
              this.clippingShow = true;
            }
          } else if (childType === 'meshClipping') {
            this.handleShow = false;
            this.meshClipping = true;
            this.showMeshClipping = true;
            if (this.isClipping) {
              this.closeClipping();
              if (this.isMobile) {
                this.mobileClipping = false;
              } else {
                this.clippingShow = false;
              }
            }
          }
          break;
        case 'outclipping':
          this.isClipping = false;

          if (this.isMobile) {
            await this.resetSectionBoxMobile();
            this.handleShow = true;
            this.mobileClipping = false;
          } else {
            await this.resetSectionBox();
            this.clippingShow = false;
          }
          this.closeClipping();
          break;
        case 'switch':
          let obj = JSON.parse(window.localStorage.getItem('clickPoint'));
          if (obj) {
            obj.cameraPosition = camera.position;
            window.localStorage.setItem('clickPoint', JSON.stringify(obj));
          }

          let setItemVal =
            defaultFile === 'gltfFineUrl' ? 'gltfMediumUrl' : 'gltfFineUrl';
          window.localStorage.setItem('defaultFile', setItemVal);
          if (!this.getQueryString('switch')) {
            location.replace(`${window.location.href}&switch=1`);
          }
          location.reload();

          break;
        case 'all':
          this.showAllConfirm = true;
          break;
      }
    },
    progressFormatter(percentage) {
      return percentage === 0 ? this.$t('准备') + '...' : `${percentage}%`;
    },
    fullscreenHandler() {
      let el = document.querySelector('.graphy');
      if (this.isFullscreen) {
        this.isFullscreen = false;
        document.exitFullscreen();
        this.activeHandle = null;
      } else {
        this.isFullscreen = true;
        el.requestFullscreen();
      }
      this.handleItems.find((item) => item.icon === 'notfull').show =
        this.isFullscreen;
      this.handleItems.find((item) => item.icon === 'fullscreen').show =
        !this.isFullscreen;
    },
    showAllHandler() {
      if (this.isPart) {
        group.traverse((e) => {
          if (e.isMesh) {
            if (e.oldMaterial) {
              e.material.dispose();
              e.material = e.oldMaterial;
              e.oldMaterial = null;
            }
          }
        });

        this.searchOps.list.forEach((element) => {
          element.checked = false;
        });

        this.checkedAllValue = false;
      } else {
        this.nodeTree[0].checked = false;
        this.setCheckedMeshes(this.nodeTreeHideMeshesUuid, true); // 重置模型的坐标

        const treeRefs = this.$refs.tree;
        treeRefs && treeRefs.setCheckedKeys([this.nodeTree[0].value]);

        this.removeLookup(); // 删除选中节点添加的模型

        // 重置模型的材质
        group.children.forEach((item) => {
          if (item.hasOwnProperty('visible')) {
            item.visible = true;
            if (oldMaterials[item.uuid]) {
              item.material.dispose();
              item.material = oldMaterials[item.uuid];
            }
          }
        });
      }

      this.showAll = false;
      this.render();
    },
    resetMeshColor() {
      if (this.isPart) return;
      if (oldRayObj) {
        this.highlightInstanceMesh(oldRayObj.object, oldRayObj.instanceId);
        oldRayObj = null;

        for (let i = group.children.length - 1; i > 0; i--) {
          let item = group.children[i];
          if (item.type === 'LineSegments') {
            group.children[i].geometry.dispose();
            group.children[i].material.dispose();
            !!group.children[i].clear && group.children[i].clear();
            group.remove(group.children[i]);
          }
        }
      }

      meshes.forEach((mesh) => {
        if (mesh.visible && mesh.material && !mesh.material.transparent) {
          mesh.material = oldMaterials[mesh.uuid];
        }
      });
    },
    async searchHandle() {
      this.searchOps.list = [];
      this.searchPage = 1;
      this.isScrolling = true;
      let value = this.searchOps.value;
      if (!value) {
        return this.$message.error('请输入属性值');
      }
      this.searchHandleRequest();
    },
    async searchHandleRequest() {
      let wholeWords = this.searchOps.wholeWords;
      let lowcase = this.searchOps.lowcase;

      let searchKey = this.searchOps.key;

      let value = !lowcase
        ? this.searchOps.value.toLocaleLowerCase()
        : this.searchOps.value;

      this.searchLoading = true;
      this.searchMsg = '搜索中...';

      Object.entries(propertiesJson).forEach(([uuid, propertyData]) => {
        Object.entries(propertyData).forEach(([i, prop]) => {
          const matchedProperty = Object.entries(prop).find(
            ([key, propValue]) => {
              propValue = propValue ? propValue : '';
              propValue = !lowcase ? propValue.toLocaleLowerCase() : propValue;

              const valueMatch =
                (wholeWords && propValue === value) ||
                (!wholeWords && propValue.indexOf(value) > -1);

              return !searchKey ? valueMatch : key === searchKey && valueMatch;
            }
          );

          if (matchedProperty && this.meshesUniqueId[uuid]) {
            this.searchOps.list.push({
              uuid: this.meshesUniqueId[uuid].uuid,
              uniqueId: uuid,
              checked: false,
              key: matchedProperty[0],
              value: matchedProperty[1],
            });
          }
        });
      });

      this.isScrolling = this.searchOps.list.length;

      this.searchMsg = !this.searchOps.list.length
        ? '（' + this.$t('空') + '）'
        : '（' + this.$t('暂无更多数据') + '）';

      this.searchLoading = false;
    },
    manualRoam(dir) {
      const pan = controls.pan;
      switch (dir) {
        case 'up':
          pan(0, -this.keyPanSpeed);
          break;
        case 'down':
          pan(0, this.keyPanSpeed);
          break;
        case 'left':
          pan(-this.keyPanSpeed, 0);
          break;
        case 'right':
          pan(this.keyPanSpeed, 0);
          break;
      }
      controls.update();
    },
    // 改变check选中状态
    searchAllHandler(checked) {
      this.showAll = true;
      this.searchOps.list.forEach((item) => {
        item.checked = checked;
      });
      if (this.isPart) {
        this.handleBasicMeshSearch();
      } else {
        checked ? this.searchItemHandler() : this.showAllHandler();
      }
    },
    handlePartMeshShow() {},
    searchItemHandler(checked) {
      this.showAll = true;
      this.isPart
        ? this.handleBasicMeshSearch(checked)
        : this.handleInstanceMeshSearch(checked);
    },
    handleBasicMeshSearch(checked) {
      const checkedMeshIds = [];
      this.searchOps.list.forEach((e) => {
        if (e.checked) {
          checkedMeshIds.push(e.uuid);
        }
      });

      const newMaterial = new THREE.MeshBasicMaterial({
        transparent: true,
        opacity: 0.2,
        color: 0x999999,
      });

      group.traverse((e) => {
        if (e.isMesh) {
          if (checkedMeshIds.includes(e.uuid)) {
            if (e.oldMaterial) {
              e.material.dispose();
              e.material = e.oldMaterial;
              e.oldMaterial = null;
            }
          } else {
            if (!e.oldMaterial) {
              e.oldMaterial = e.material.clone();
              e.material.dispose();
              e.material = newMaterial.clone();
            }
          }
        }
      });

      this.highlightLineAction('delete');

      this.render();
    },
    handleInstanceMeshSearch(checked) {
      let uuids = {};
      this.searchOps.list.forEach((item) => {
        if (item.checked) {
          let { mesh } = this.meshesUniqueId[item.uniqueId];
          if (mesh) {
            if (mesh.children.length) {
              mesh.children.forEach((child) => {
                uuids[child.uuid] = {
                  object: instanceMeshes[child.uuid],
                  instanceId: instanceMeshes[child.uuid].repeatMeshes.findIndex(
                    (v) => v.uuid === child.uuid
                  ),
                };
              });
            }
          }
        }
      });

      if (checked) {
        for (const item of Object.values(uuids)) {
          this.lookAtMesh(item);
        }
      } else {
        this.highlightLineAction('delete');
      }
      this.opacityMesh(uuids);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getQueryString(field) {
      return getUrlStringQueryParam(window.location.href, field);
    },
    initRenderer() {
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true,
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(this.el.offsetWidth, this.el.offsetHeight);
      renderer.setClearColor(0xf0f2f0, 1);
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      // renderer.outputEncoding = sRGBEncoding;
      this.el.appendChild(renderer.domElement);

      pmremGenerator = new THREE.PMREMGenerator(renderer);
      pmremGenerator.compileEquirectangularShader();

      labelRenderer = new CSS2DRenderer();
      labelRenderer.setSize(this.el.offsetWidth, this.el.offsetHeight);
      labelRenderer.domElement.style.position = 'absolute';
      labelRenderer.domElement.style.top = '0px';
      this.el.appendChild(labelRenderer.domElement);
    },
    initScene() {
      scene = new THREE.Scene();
    },
    initCamera() {
      camera = new THREE.PerspectiveCamera(
        35,
        this.el.offsetWidth / this.el.offsetHeight,
        0.1,
        10000
      );
    },
    mergeTree(a, b) {
      if (!Array.isArray(a)) a = [a];
      if (!Array.isArray(b)) b = [b];
      return [...a, ...b].reduce((r, o) => {
        if (!o) {
          return r;
        }
        const item = r.find(({ index }) => o.index === index);
        if (item) {
          item.children = this.mergeTree(item.children, o.children);
        } else r.push(o);
        return r;
      }, []);
    },
    async initPartMeshes() {},
    async initMeshes(filePath, qrcode = null) {
      this.partLoadingText = '获取模型属性中...';
      await this.getPropertiesJson(filePath.propertyUrl);

      const gltfLoader = new GLTFLoader();
      const dracoLoader = new DRACOLoader();
      dracoLoader.setDecoderPath(`/draco/`);
      dracoLoader.setDecoderConfig({ type: 'js' });
      dracoLoader.preload();
      gltfLoader.setDRACOLoader(dracoLoader);

      let nodeTree = null;
      let geometryMaterialAll = {};
      let qrcodeMesh = {};
      let qrcodeMeshes = [];

      for (let url of filePath[defaultFile]) {
        let part = await this.loadGltf(gltfLoader, url, filePath.fileSize);
        if (!scale) {
          scale = part.scene.children[0].scale.clone();
        }

        if (!nodeTree) {
          nodeTree = [this.getNodesTree(part.scene)];
        } else {
          nodeTree = this.mergeTree(nodeTree, this.getNodesTree(part.scene));
        }

        // 收集相同材质的mesh
        part.scene.traverse((child) => {
          child.updateMatrixWorld();
          if (child.isMesh) {
            if (qrcode) {
              const properties = this.getObjProperty(child);
              if (properties) {
                if (
                  properties['文字'] &&
                  properties['文字']['铝模板位置编号'] === qrcode
                ) {
                  qrcodeMesh[child.uuid] = child;
                }
              }
              qrcodeMeshes[child.uuid] = child;
            } else {
              if (Array.isArray(child.material)) {
                child.material.forEach((m) => {
                  let key =
                    child.geometry.userData.uuid + '-' + m.userData.uuid;
                  !geometryMaterialAll[key]
                    ? (geometryMaterialAll[key] = [child])
                    : geometryMaterialAll[key].push(child);
                });
              } else {
                let key =
                  child.geometry.userData.uuid +
                  '-' +
                  child.material.userData.uuid;
                !geometryMaterialAll[key]
                  ? (geometryMaterialAll[key] = [child])
                  : geometryMaterialAll[key].push(child);
              }
            }
          }
        });

        if (!viewScale) {
          viewScale =
            part.asset.view_scale /
            part.scene.children[0].matrix.getMaxScaleOnAxis();
        }
      }
      this.nodeTree = [nodeTree[0]];
      this.defaultCheckedKeys = defaultCheckedKeys;
      let gmAll = {};
      if (Object.values(qrcodeMesh).length) {
        const oneQrcodeMesh = Object.values(qrcodeMesh)[0];
        const targetBox = new THREE.Box3().setFromObject(oneQrcodeMesh);
        targetBox.expandByScalar(500);
        for (const i in qrcodeMeshes) {
          let mesh = qrcodeMeshes[i];
          //使用碰撞检测算法
          if (targetBox.intersectsBox(new THREE.Box3().setFromObject(mesh))) {
            mesh.userData = this.getUniqueId(mesh);
            const matrix = mesh.parent
              ? mesh.parent.matrixWorld
              : mesh.matrixWorld;
            mesh.applyMatrix4(matrix);
            mesh.material = mesh.material.clone();
            group.add(mesh);
            meshes.push(mesh);
          }
        }

        this.highlightMesh({ object: oneQrcodeMesh });
      } else {
        gmAll = geometryMaterialAll;
      }
      if (Object.values(qrcodeMesh).length) {
        this.loadingPercent = 100;
        helperBox = new THREE.Box3().setFromObject(group);
        this.setContent(group);
      } else {
        for (const i in gmAll) {
          let item = gmAll[i];
          if (item.length === 0) {
            continue;
          }
          let geometry = item[0].geometry.clone();
          let material = item[0].material;
          material.side = THREE.DoubleSide;
          let mesh = new THREE.InstancedMesh(geometry, material, item.length);
          mesh.oldMatrix = {};
          mesh.repeatMeshes = item;
          item.forEach((v, key) => {
            instanceMeshes[v.uuid] = mesh;
            v.updateMatrixWorld();
            v.updateMatrix();
            helperBox.expandByObject(v);
            let matrix = this.getMatrix(v);
            mesh.setMatrixAt(key, matrix);
            mesh.oldMatrix[key] = matrix;
            mesh.setColorAt(key, new THREE.Color());
          });
          meshes.push(mesh);
          oldMaterials[mesh.uuid] = mesh.material;
        }

        await new Promise((resolve, reject) => {
          const len = 100;
          const count = Math.ceil(meshes.length / len);
          let cur = 0;
          let star = 0;
          const intervalId = setInterval(() => {
            const end = star + len;
            const arr = meshes.slice(star, end);
            for (const item of arr) {
              group.add(item);
            }
            this.meshLoadingProgress = Math.ceil(
              (star / meshes.length || 0) * 100
            );
            cur += 1;
            if (cur == 1) {
              this.loadingPercent = 100;
              this.setContent(group);
            }
            this.render();
            star = end;
            if (cur >= count) {
              clearInterval(intervalId);
              resolve(true);
            }
          }, 100);
        });

        // 记录唯一ID指向的模型对象，属性搜索功能中用到
        meshes.forEach((item) => {
          item.repeatMeshes.forEach((mesh) => {
            let uniqueId = this.getObjPropertyUniqueId(mesh);
            if (uniqueId) {
              this.meshesUniqueId[uniqueId] = {
                uuid: mesh.parent.uuid,
                mesh: mesh.parent,
              };
            }
          });
        });
      }

      this.meshLoadingProgress = 100;

      this.el.addEventListener('click', this.onMaterialClick);
      this.updateEnvironment();
      this.resizeRegister();

      // 切换视图展示，相机视角保持和上个一样
      this.clickPoint = JSON.parse(window.localStorage.getItem('clickPoint'));
      if (this.clickPoint && this.getQueryString('switch')) {
        for (let i = 0; i < meshes.length; i++) {
          let mesh = meshes[i];
          for (let j = 0; j < mesh.repeatMeshes.length; j++) {
            let child = mesh.repeatMeshes[j];
            let { UniqueId } = this.getUniqueId(child);
            if (UniqueId === this.clickPoint.UniqueId) {
              let obj = {
                instanceId: j,
                object: mesh,
              };
              this.highlightMesh(obj, true);
              window.localStorage.removeItem('clickPoint');
              return;
            }
          }
        }
      }
    },
    async getMeshCache() {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: `${requestUrl}/api/BuildedCache/info`,
          dataType: 'json',
          crossDomain: true,
          cache: false,
          params: {
            id: this.modelId,
            code_new: this.modelCode,
            type: defaultFile === 'gltfFineUrl' ? 1 : 2,
          },
        })
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async saveMeshCache(meshJson, boxCenter) {
      axios({
        method: 'post',
        url: `${requestUrl}/api/BuildedCache/store`,
        dataType: 'json',
        crossDomain: true,
        cache: false,
        data: {
          id: this.modelId,
          cache: meshJson,
          code_new: this.modelCode,
          box_center: JSON.stringify(boxCenter),
          type: defaultFile === 'gltfFineUrl' ? 1 : 2,
        },
      })
        .then((result) => {
          if (result.data.code == 200) {
          }
        })
        .catch((error) => {});
    },
    async getPropertiesJson(url) {
      if (propertiesJson) return;
      let res = await new Data.getInstance().getJson(url);
      propertiesJson = res.data;
    },
    resizeRegister() {
      window.onresize = () => {
        let el = document.querySelector('.graphy');
        let width = el.clientWidth;
        let height = el.clientHeight;
        if (window.innerHeight !== screen.height) {
          height =
            window.innerHeight - document.querySelector('.title').clientHeight;
        }
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.domElement.style.width = width + 'px';
        renderer.domElement.style.height = height + 'px';
        renderer.setSize(width, height, false);
        this.render();
      };
    },
    updateEnvironment() {
      let path = `/draco/venice_sunset_1k.hdr`;

      this.getCubeMapTexture(path).then(({ envMap }) => {
        scene.environment = envMap;
        this.render();
        this.loadingPercent = 100;
        // scene.background =  envMap;
      });
    },
    resetScene() {
      controls.target.set(0, 0, 0);
      let p = originalCamera.position;
      camera.position.set(p.x, p.y, p.z);
      let r = originalCamera.rotation;
      camera.rotation.set(r.x, r.y, r.z);
      this.render();
    },
    getCubeMapTexture(path) {
      return new Promise((resolve, reject) => {
        new RGBELoader().load(
          path,
          (texture) => {
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            pmremGenerator.dispose();

            resolve({ envMap });
          },
          undefined,
          reject
        );
      });
    },
    async getFilePath() {
      const type = defaultFile === 'gltfFineUrl' ? 1 : 2;
      let res = await new Data.getInstance().get({
        url: `${requestUrl}/api/info/${this.modelId}?code_new=${this.modelCode}&type=${type}`,
        method: 'GET',
      });
      if (res.data.code === '200') {
        return res.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
    loadGltf(gltfLoader, gltfPath, fileSize) {
      let xhrTotal = 0;
      return new Promise((resolve, reject) => {
        gltfLoader.load(
          gltfPath,
          (gltf) => {
            fileLoadedSize += xhrTotal;
            resolve(gltf);
          },
          (xhr) => {
            xhrTotal = xhr.total;
            let loaded = fileLoadedSize + xhr.loaded;
            let p = (loaded / Number(fileSize)) * 100 - 1;
            let loadingPercent = p < 1 ? 1 : parseFloat(checkDeci(p, 0));
            this.loadingPercent = loadingPercent > 100 ? 100 : loadingPercent;
          },
          (error) => {}
        );
      });
    },
    setContent(group, cacheCameraSize = null, groupPostion = null) {
      // 设置origin居中原点
      const box = helperBox;
      const center = box.getCenter(new THREE.Vector3());
      const vector = box.getSize(new THREE.Vector3());
      cameraSize = cacheCameraSize || vector.length();

      if (!groupPostion) {
        group.position.x += group.position.x - center.x;
        group.position.y += group.position.y - center.y;
        group.position.z += group.position.z - center.z;
        helperBox.translate(
          new THREE.Vector3(
            group.position.x,
            group.position.y,
            group.position.z
          )
        );
      } else {
        group.position.set(groupPostion.x, groupPostion.y, groupPostion.z);
      }

      bottomPlane = new THREE.Plane(
        new THREE.Vector3(0, -1, 0),
        group.position.y
      );

      camera.near = cameraSize / 100;
      camera.far = cameraSize * 100;
      camera.updateProjectionMatrix();

      if (this.isMobile) {
        camera.position.set(
          cameraSize / 0.65,
          cameraSize / 0.65,
          cameraSize / 0.65
        );
      } else {
        camera.position.set(cameraSize / 1, cameraSize / 1, cameraSize / 1);
      }

      originalCamera = {
        position: camera.position.clone(),
        rotation: camera.rotation.clone(),
      };
      scene.add(group);
      this.render();
    },
    render() {
      renderRequested = false;

      controls.update();
      TWEEN.update();

      renderer.render(scene, camera);
      labelRenderer.render(scene, camera);
    },
    requestRenderIfNotRequested() {
      if (!renderRequested) {
        renderRequested = true;
        requestAnimationFrame(this.render);
      }
    },
    setLight() {
      ambientLight = new THREE.AmbientLight(0xffffff, 0.2);
      scene.add(ambientLight);
    },
    initControls(camera, renderer) {
      controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = false;
      controls.enableZoom = true;
      controls.autoRotate = false;
      controls.autoRotateSpeed = 3;
      controls.enablePan = true;
      controls.enableKeys = false;
      this.fullscreenControls();
      this.pcKeyboardControl();
      this.pcMousemoveControls();

      controls.addEventListener('change', () => {
        if (this.tapStart) {
          this.originPointerShow = true;
        }
        this.requestRenderIfNotRequested();
      });

      controls.addEventListener('start', (e) => {
        if (e.original) {
          if (e.original.button === 0) {
            this.tapStart = true;
            this.el.style.cursor = 'default';
          } else {
            this.el.style.cursor = 'grabbing';
          }
          this.tapStartTimestmap = e.original.timeStamp;
        }
      });
      controls.addEventListener('end', (e) => {
        this.tapStart = false;
        this.originPointerShow = false;
        this.el.style.cursor = 'default';
        this.render();
      });
      // orientation helper
      const ohOptions = {
          className: this.isMobile
            ? 'orientation-helper-in-scene-mobile'
            : 'orientation-helper-in-scene',
          width: this.isMobile ? 100 : 150,
          height: this.isMobile ? 100 : 150,
        },
        ohLabels = {
          px: this.$t('右'),
          nx: this.$t('左'),
          pz: this.$t('前'),
          nz: this.$t('后'),
          py: this.$t('上'),
          ny: this.$t('下'),
        };

      let translateCamera = (direction) => {
        controls.enabled = false;
        const dist = camera.position.distanceTo(controls.target),
          newCameraPos = controls.target
            .clone()
            .add(direction.multiplyScalar(dist));
        camera.position.set(newCameraPos.x, newCameraPos.y, newCameraPos.z);
        controls.enabled = true;
        controls.update();
      };

      let onOrientationHelperChange = (ev) => {
        translateCamera(ev.direction);
      };

      let onOrientationHelperClick = (ev) => {
        // Simulate double-click (less than 250ms)
        let nClick = Date.now();
        if (nClick - lastClickTime < 250) {
          translateCamera(ev.normal);
        }

        lastClickTime = nClick;
      };

      let orientationHelper = new OrientationHelper(
        camera,
        controls,
        ohOptions,
        ohLabels
      );
      orientationHelper.addEventListener('change', onOrientationHelperChange);
      orientationHelper.addEventListener('click', onOrientationHelperClick);

      this.el.appendChild(orientationHelper.domElement);
    },
    fullscreenControls() {
      !this.isMobile &&
        window.addEventListener(
          'fullscreenchange',
          (e) => {
            // presss esc button
            if (!document.webkitIsFullScreen && this.isFullscreen) {
              this.isFullscreen = false;
              this.handleItems.find((item) => item.icon === 'notfull').show =
                this.isFullscreen;
              this.handleItems.find((item) => item.icon === 'fullscreen').show =
                !this.isFullscreen;
            }
          },
          false
        );
    },
    pcKeyboardControl() {
      const pan = controls.pan;
      !this.isMobile &&
        window.addEventListener(
          'keydown',
          (event) => {
            if (measureLengthStart && event.code === 'Escape' && moveLine) {
              measurePoints = [];
              moveLine = null;
              this.removeLine(/move_line|distance_point/);
              this.render();
            }

            if (!this.roamShow) return;

            let needsUpdate = false;

            switch (event.code) {
              case 'KeyQ':
                pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;

              case 'KeyE':
                pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;

              case 'ArrowUp':
              case 'KeyW':
                {
                  let step = originalCamera.position.x / 50;
                  let sp = new THREE.Spherical().setFromVector3(
                    camera.position
                  );
                  if (originalRadius === null) {
                    originalRadius = sp.radius;
                    step = originalRadius / 20;
                  }
                  sp.radius -= step * this.panRate;
                  let p = new THREE.Vector3().setFromSpherical(sp);
                  camera.position.set(p.x, p.y, p.z);

                  needsUpdate = true;
                }
                break;

              case 'ArrowDown':
              case 'KeyS':
                {
                  let step = originalCamera.position.x / 50;
                  let sp = new THREE.Spherical().setFromVector3(
                    camera.position
                  );
                  if (originalRadius === null) {
                    originalRadius = sp.radius;
                    step = originalRadius / 20;
                  }
                  sp.radius += step * this.panRate;
                  let p = new THREE.Vector3().setFromSpherical(sp);
                  camera.position.set(p.x, p.y, p.z);
                  needsUpdate = true;
                }
                break;

              case 'ArrowLeft':
              case 'KeyA':
                pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;

              case 'ArrowRight':
              case 'KeyD':
                pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;

              case 'NumpadAdd':
                this.panRate = this.panRate + 1 > 10 ? 10 : this.panRate + 1;
                break;

              case 'NumpadSubtract':
                this.panRate = this.panRate - 1 < 1 ? 1 : this.panRate - 1;
                break;
              case 'Equal':
                if (event.shiftKey)
                  this.panRate = this.panRate + 1 > 10 ? 10 : this.panRate + 1;
                break;
              case 'Minus':
                if (event.shiftKey)
                  this.panRate = this.panRate - 1 < 1 ? 1 : this.panRate - 1;
                break;
            }

            if (needsUpdate) {
              // prevent the browser from scrolling on cursor keys
              event.preventDefault();
              controls.update();
              // this.render();
            }
          },
          false
        );
    },
    pcMousemoveControls() {
      if (this.isMobile) return;

      let mouse = new THREE.Vector2();
      let container = this.el;
      let getBoundingClientRect = container.getBoundingClientRect();
      let findEdgePoint = (clientX, clientY) => {
        let length = 5;
        let steps = [];
        // 向右或向上正数的查询无效，只能向左或向下负数的查询，具体原因未知，品茗同样如此
        for (let i = -length; i < 0; i++) {
          // if (i === 0) continue;
          if (i < 0) {
            steps.unshift(-1);
          } else {
            steps.push(1);
          }
        }
        let stepIndex = -1;
        let edgePoint = null;
        let preHoverMesh = null;
        let findPoint = (x, y, sign) => {
          mouse.x =
            ((x - getBoundingClientRect.left) / container.offsetWidth) * 2 - 1;
          mouse.y =
            -((y - getBoundingClientRect.top) / container.offsetHeight) * 2 + 1;
          raycaster.setFromCamera(mouse, camera);
          var intersects = raycaster.intersectObjects(meshes, true);
          if (intersects.length > 0) {
            let obj = intersects[0].object;
            if (obj.isMesh) {
              if (!preHoverMesh) {
                preHoverMesh = obj;
              }
              if (preHoverMesh.uuid === obj.uuid && stepIndex < length * 2) {
                stepIndex++;
                preHoverMesh = obj;
                if (stepIndex < length) {
                  findPoint(x + steps[stepIndex], y, [-steps[stepIndex], 0]);
                } else {
                  findPoint(x, y + steps[stepIndex - length], [
                    0,
                    -steps[stepIndex - length],
                  ]);
                }
              } else {
                edgePoint = {
                  x: x + sign[0],
                  y: y + sign[1],
                };
              }
            }
          }
        };
        findPoint(clientX, clientY, [0, 0]);
        return {
          edgePoint,
        };
      };
      let lastMeshPoint = null;
      controls.addEventListener('mousemove', (event) => {
        let target = event.original;
        target.preventDefault();
        let { clientX, clientY } = target;
        mouse.x =
          ((clientX - getBoundingClientRect.left) / container.offsetWidth) * 2 -
          1;
        mouse.y =
          -((clientY - getBoundingClientRect.top) / container.offsetHeight) *
            2 +
          1;
        raycaster.setFromCamera(mouse, camera);
        let intersects = raycaster.intersectObjects(meshes, false);

        if (intersects.length && intersects[0].point) {
          lastMeshPoint = intersects[0].point;
        }

        if (measurePoints.length === 1) {
          this.createMoveLine([measurePoints[0], lastMeshPoint]);
        }
        let { edgePoint } = findEdgePoint(clientX, clientY);
        lastEdgePoint = edgePoint;
        if (edgePoint) {
          let pit = document.querySelector('.pit-icon');
          let getBoundingClientRect = this.el.getBoundingClientRect();
          pit.style.top = edgePoint.y - getBoundingClientRect.top + 'px';
          pit.style.left = edgePoint.x - getBoundingClientRect.left + 'px';
          this.pitShow = true;
        } else {
          this.pitShow = false;
        }
        this.render();
      });
    },
    onMaterialClick(target, isDouble) {
      if (!target || !this.tapStartTimestmap) return;
      if (
        target.timeStamp - this.tapStartTimestmap > 500 ||
        target.button !== 0
      ) {
        return;
      }
      target.preventDefault();
      let rayObj = this.findObjWithPoint(target.clientX, target.clientY);
      if (rayObj) {
        const clickObject = rayObj.object;
        const clickObjectMesh = clickObject.repeatMeshes
          ? clickObject.repeatMeshes[rayObj.instanceId]
          : clickObject;

        let obj = {
          point: rayObj.point,
          cameraPosition: camera.position,
          currName: clickObjectMesh.name,
          ...this.getUniqueId(clickObjectMesh),
        };
        window.localStorage.setItem('clickPoint', JSON.stringify(obj));

        if (measureStart) {
          this.modelMeasurementClick(rayObj.point);
        }
        if (!rayObj.object.isMesh) return;
        this.highlightMesh(rayObj, isDouble);
      } else {
        this.resetMeshColor();
      }
      this.requestRenderIfNotRequested();
    },
    distanceToBottom(point) {
      this.createPoint(point);
      let dis = this.createLabel(
        `<div><span class='distance-label-shadow'>${Math.abs(
          bottomPlane.distanceToPoint(point) / 1000 / scale.x
        ).toFixed(2)}m</span></div>`,
        'distance-label distance-bottom-label'
      );
      dis.position.set(point.x, point.y, point.z);
      dis.name = 'distance_line';
      scene.add(dis);
      this.render();
    },
    createLabel(
      text,
      className = 'distance-label distance-label-shadow',
      style = ''
    ) {
      const div = document.createElement('div');
      div.className = className;
      div.innerHTML = text;
      if (style) {
        div.style = style;
      }
      return new CSS2DObject(div);
    },
    createPoint(point) {
      let mat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
      let sphereGeometry = new THREE.SphereGeometry(3, 32, 32);
      let sphere = new THREE.Mesh(sphereGeometry, mat);
      sphere.position.set(...point);
      sphere.name = 'distance_point';
      scene.add(sphere);
      this.render();
    },
    removeLine(lineReg) {
      for (let i = scene.children.length - 1; i > -1; i--) {
        let child = scene.children[i];
        if (lineReg.test(child.name)) {
          if (child.children.length > 0) {
            child.remove(child.children[0]);
          }
          child.geometry && child.geometry.dispose();
          child.material && child.material.dispose();
          !!child.clear() && child.clear();
          scene.children.splice(i, 1);
        }
      }
    },
    createLine(points, isHelperLine, color) {
      let distance = points[0].distanceTo(points[1]);
      let label = this.createLabel(
        `${(distance / scale.x / 1000).toFixed(2)}m`,
        'distance-label distance-label-shadow',
        color ? `color: ${color}` : ''
      );

      let line3 = new THREE.Line3(...points);
      label.position.copy(line3.getCenter(new THREE.Vector3()));
      let geometry = new THREE.BufferGeometry().setFromPoints(points);
      let line = new THREE.Line(
        geometry,
        new THREE.LineBasicMaterial({
          color: color || '#f00',
          depthTest: false,
        })
      );
      line.name = isHelperLine ? 'helper_line' : 'distance_line';
      line.layers.enableAll();
      line.add(label);
      scene.add(line);
      if (!isHelperLine) {
        this.createHelperLine(points);
      }
      this.render();
    },
    createHelperLine(points) {
      let [p0, p1] = points;
      let sameAxis = ['x', 'y', 'z'].find(
        (ax) => p0[ax].toFixed(2) === p1[ax].toFixed(2)
      );
      let h1 = null,
        h2 = null;
      if (sameAxis) {
        if (sameAxis === 'x') {
          h1 = new THREE.Vector3(p0.x, p1.y, p0.z);
        } else if (sameAxis === 'y') {
          h1 = new THREE.Vector3(p1.x, p0.y, p0.z);
        } else {
          h1 = new THREE.Vector3(p1.x, p0.y, p0.z);
        }
        this.createLine([p0, h1], true, '#ffc107');
        this.createLine([p1, h1], true, '#03a9f4');
      } else {
        h1 = new THREE.Vector3(p1.x, p1.y, p0.z);
        h2 = new THREE.Vector3(p1.x, p0.y, p0.z);
        this.createLine([p1, h1], true, '#ffc107');
        this.createLine([h1, h2], true, '#03a9f4');
        this.createLine([h2, p0], true, '#9c27b0');
      }
    },
    createMoveLine(points) {
      if (!points[1]) return;
      let distance = points[0].distanceTo(points[1]);
      let label = this.createLabel(
        `${(distance / scale.x / 1000).toFixed(2)}m`
      );
      let line3 = new THREE.Line3(...points);
      label.position.copy(line3.getCenter(new THREE.Vector3()));
      if (moveLine) {
        if (moveLine.children.length > 0) {
          moveLine.remove(moveLine.children[0]);
        }
        moveLine.add(label);
        const pos =
          (moveLineGeometry.attributes &&
            moveLineGeometry.attributes.position) ||
          undefined;
        if (pos) {
          let point = points[1];
          let i = 3;
          pos.array[i++] = point.x;
          pos.array[i++] = point.y;
          pos.array[i++] = point.z;
          pos.needsUpdate = true;
        }
      } else {
        moveLineGeometry.setFromPoints(points);
        moveLine = new THREE.LineSegments(
          moveLineGeometry,
          new THREE.LineBasicMaterial({
            color: 0xff0000,
            depthTest: false,
            side: THREE.DoubleSide,
            // depthWrite: false,
            // transparent: true
          })
        );
        moveLine.name = 'move_line';
        moveLine.layers.enableAll();
        moveLine.add(label);
        scene.add(moveLine);
      }
      this.requestRenderIfNotRequested();
    },
    measureClose() {
      measurePoints = [];
      this.handleItems = this.handleItemsOrigin;
      measureLengthStart = false;
      measureHeightStart = false;
      this.pitShow = false;
      this.removeLine(/distance_|helper_line|move_line/);
      document.querySelectorAll('.distance-label').forEach((item) => {
        item.remove();
      });
      this.render();
    },
    getNodesTree(scene) {
      let checkObjNoMesh = (obj) => {
        let noMesh = true;
        let r = (obj) => {
          if (obj.isMesh) {
            noMesh = false;
          } else {
            for (let child of obj.children) {
              r(child);
            }
          }
        };
        r(obj);
        return noMesh;
      };

      let getTree = (obj) => {
        let tree = {
          label: obj.name,
          index: obj.userData.UniqueId || obj.uuid, // 用于合并的时候查找
          value: obj.uuid,
          type: obj.type,
          checked: true,
        };

        defaultCheckedKeys.push(tree.value);

        if (obj.children.length > 0) {
          tree.children = [];
          for (let child of obj.children) {
            if (!checkObjNoMesh(child)) {
              tree.children.push(getTree(child));
            }
          }
          if (tree.children.length === 0) {
            delete tree.children;
          }
        }
        return tree;
      };

      return getTree(scene.children[0]);
    },
    onNodeCheckChange(data, checked) {
      this.showAll = true;
      this.opacityMeshLoading = false;
      // 获取选中节点、mesh模型的uuid
      const isChecked = checked.checkedKeys.includes(data.value) > 0;
      const keys = {};
      const checkedkeys = (data, keys) => {
        data.forEach((e) => {
          keys[e.value] = 1;
          if (e.children && e.children.length) {
            checkedkeys(e.children, keys);
          }
        });
      };
      checkedkeys([data], keys);
      this.setCheckedMeshes(keys, isChecked);
    },
    /**
     * @description: 设置模型显示隐藏
     * @param {Object} checkedKeys 选中节点uuid
     * @param {Boolean} isShow 是否隐藏 true显示 false隐藏
     */
    setCheckedMeshes(keys, isShow) {
      Object.keys(keys).forEach((uuid) => {
        let instanceMesh = instanceMeshes[uuid];
        if (instanceMesh) {
          if (isShow) {
            instanceMesh.visible = true; // 存在显示

            if (hideInstanceMeshes[uuid]) {
              // 是否移动过模型位置，true复原并删除记录
              const { matrix, instanceId } = hideInstanceMeshes[uuid];
              instanceMesh.repeatMeshes[instanceId].updateMatrix();
              instanceMesh.setMatrixAt(instanceId, matrix);
              instanceMesh.instanceMatrix.needsUpdate = true;

              delete hideInstanceMeshes[uuid];
            }
            if (this.nodeTreeHideMeshesUuid[uuid]) {
              delete this.nodeTreeHideMeshesUuid[uuid];
            }
          } else {
            this.nodeTreeHideMeshesUuid[uuid] = 1;
            if (instanceMesh.count === 1) {
              // 只存在一个instanceMeshes直接隐藏
              instanceMesh.visible = false;
            } else {
              const repeatMeshes = instanceMesh.repeatMeshes;
              // 获取在instanceMesh中下标
              let instanceId = repeatMeshes.findIndex((e) => e.uuid === uuid);

              let matrix = this.getMatrix(repeatMeshes[instanceId]);
              // 存储修改矩阵的mesh
              hideInstanceMeshes[uuid] = { instanceId, matrix };

              // 修改mesh矩阵定位，达到隐藏的效果
              let dummy = new THREE.Object3D();
              dummy.position.set(99999, 99999, 99999);
              dummy.updateMatrix();
              instanceMesh.setMatrixAt(instanceId, dummy.matrix);
              instanceMesh.instanceMatrix.needsUpdate = true;
            }
          }
        }
      });
      this.render();
      this.opacityMeshLoading = false;
      this.showAll = JSON.stringify(this.nodeTreeHideMeshesUuid) !== '{}';
    },
    onNodeClick(data) {
      this.showAll = true;
      let nodeClickedMeshes = {};
      let getMeshes = (node, obj) => {
        obj[node.value] = 1;
        if (node.children && node.children.length) {
          node.children.forEach((child) => {
            getMeshes(child, obj);
          });
        }
      };
      getMeshes(data, nodeClickedMeshes);
      this.opacityMesh(nodeClickedMeshes, data.value);
    },
    async lookAtMesh(mesh, isLookat = false) {
      // 设置线条高亮线条材质并返回
      let highlightLine = await this.setHighlightLine(mesh);
      // 相机聚焦高亮线条材质
      let box = new THREE.Box3().setFromObject(highlightLine);
      let objSize = box.getSize(new THREE.Vector3());
      let objCenter = box.getCenter(new THREE.Vector3());
      let size_length = objSize.length();
      let center_length = objCenter.length();
      let r = Math.sqrt(size_length ** 2 + center_length ** 2);
      let num = size_length > 1000 ? 5 : 20;
      let pos = objCenter.multiplyScalar((r + num * size_length) / r);
      if (isLookat) {
        if (this.clickPoint) {
          const { cameraPosition, point } = this.clickPoint;
          this.animateCamera(
            camera.position,
            cameraPosition,
            controls.target,
            point
          );
        } else {
          this.animateCamera(camera.position, pos, controls.target, mesh.point);
        }
        this.clickPoint = null;
      } else {
        camera.position.set(
          ...objCenter.multiplyScalar((r + num * size_length) / r)
        );
        this.render();
      }
    },
    /**
     * @description: 高亮line操作
     * @param {String} action 不传值默认返回
     */
    async highlightLineAction(action) {
      await new Promise((resolve, reject) => {
        for (let i = 0; i <= scene.children.length - 1; i++) {
          const item = scene.children[i];
          if (!item.isGroup) continue;
          for (let j = item.children.length - 1; j >= 0; j--) {
            const child = item.children[j];
            if (child.name === 'highlight_line') {
              // 操作
              if (action === 'delete') {
                child.geometry.dispose();
                child.material.dispose();
                !!child.clear && child.clear();
                item.remove(child);
              } else {
                return child;
              }
            }
          }
        }
        resolve(true);
      });
    },
    /**
     * @description: 设置高亮线条材质
     */
    async setHighlightLine(mesh) {
      return await new Promise(async (resolve, reject) => {
        await this.highlightLineAction('delete');

        const { object, instanceId } = mesh;
        const { geometry, oldMatrix, repeatMeshes } = object;

        if (repeatMeshes && repeatMeshes[instanceId]) {
          const childrenMeshes = repeatMeshes[instanceId].parent;
          if (childrenMeshes.type === 'Group') {
            childrenMeshes.children.forEach((item) => {
              let matrix = this.getMatrix(item);
              this.createHighLine(item.geometry, matrix);
            });
            this.render();
          }
        }
        const matrix = oldMatrix ? oldMatrix[instanceId] : object.matrix;
        let line = this.createHighLine(geometry, matrix);
        resolve(line);
      });
    },
    getObjProperty(mesh) {
      if (!propertiesJson) return;
      let r = (obj) => {
        if (propertiesJson[obj.userData.UniqueId]) {
          return {
            ...propertiesJson[obj.userData.UniqueId],
            UniqueId: obj.userData.UniqueId,
          };
        } else if (obj.parent) {
          return r(obj.parent);
        }
      };
      return r(mesh);
    },
    getObjPropertyUniqueId(mesh) {
      if (!propertiesJson) return;
      let r = (obj) => {
        if (propertiesJson[obj.userData.UniqueId]) {
          return obj.userData.UniqueId;
        } else if (obj.parent) {
          return r(obj.parent);
        }
      };
      return r(mesh);
    },
    /**
     * @descirption 新增instanceMesh
     * @param {Object} meshes 要添加到场景的mesh
     * @param {Number|Boolean} isTransparent 材质是否要透明
     */
    async addInstancedMesh(meshes) {
      try {
        await new Promise((resolve, reject) => {
          for (let i in meshes) {
            let item = meshes[i];
            let geometry = item[0].geometry.clone(),
              material;
            material = item[0].material;
            let cube = new THREE.InstancedMesh(geometry, material, item.length);
            cube.name = 'lookup';
            cube.oldMatrix = {};
            cube.repeatMeshes = [item];

            item.forEach((v, key) => {
              v.updateMatrixWorld();
              v.updateMatrix();
              let matrix = this.getMatrix(v);
              cube.setMatrixAt(key, matrix);
              cube.oldMatrix[key] = matrix;
              cube.setColorAt(key, new THREE.Color());
            });
            group.add(cube);
          }
          resolve(true);
        });
      } catch (error) {}
    },
    async opacityMesh(nodeClickedMeshes, hideValue) {
      this.opacityMeshLoading = true;

      // 隐藏所有instancemesh，手动添加选中模型
      const handler = (nodeCheckedMeshes) => {
        let repeatMeshes = {};
        let newMaterial = new THREE.MeshBasicMaterial({
          transparent: true,
          opacity: 0.2,
          color: 0x999999,
        });

        meshes.forEach((child) => {
          // 设置材质透明度
          child.material.dispose();
          child.material = newMaterial;

          if (child.repeatMeshes) {
            // 处理属性查找选中的mesh
            child.repeatMeshes.forEach((mesh) => {
              if (nodeCheckedMeshes[mesh.uuid]) {
                // 选中mesh新添加一个InstancedMesh
                const { geometry, material } = mesh;
                const uuid = `${geometry.userData.uuid}-${material.userData.uuid}`;
                repeatMeshes[uuid]
                  ? repeatMeshes[uuid].push(mesh)
                  : (repeatMeshes[uuid] = [mesh]);
              }
            });
          }
        });

        return repeatMeshes;
      };

      this.removeLookup(); // 删除透明的模式

      // 属性搜索取消选中触发，结构树点击节点取消触发
      if (hideValue) {
        meshes.forEach((child, key) => {
          if (child.material.uuid !== oldMaterials[child.uuid].uuid) {
            child.material.dispose();
            child.material = oldMaterials[child.uuid];
          }
        });
      }

      if (hideValue === undefined || this.hideValue !== hideValue) {
        const repeatMeshes = handler(nodeClickedMeshes);
        if (Object.values(repeatMeshes).length) {
          await this.addInstancedMesh(repeatMeshes);
        }
        this.hideValue = hideValue;
      } else {
        this.hideValue = '';
      }

      this.render();
      this.opacityMeshLoading = false;
    },
    async highlightMesh(rayObj, isLookat) {
      const { object, instanceId } = rayObj;
      rayObj.uuid = `${object.geometry.userData.uuid}-${object.material.userData.uuid}`;
      const oldUuid = oldRayObj ? oldRayObj.uuid : '';
      if (!object.visible) {
        return;
      }

      const clickMesh = object.repeatMeshes
        ? object.repeatMeshes[instanceId]
        : object;
      this.properties = this.getObjProperty(clickMesh);

      if (oldRayObj) {
        // 删除高亮line
        await this.highlightLineAction('delete');
        if (oldRayObj.instanceId !== undefined) {
          this.highlightInstanceMesh(oldRayObj.object, oldRayObj.instanceId);
        } else {
          this.highlightInstanceMesh(
            oldRayObj.object,
            oldRayObj.instanceId,
            oldRayObj.color
          );
        }
      }

      if (rayObj.uuid === oldUuid && instanceId === oldRayObj.instanceId) {
        // 清除高亮颜色
        oldRayObj = null;
        return false;
      }
      oldRayObj = {
        ...rayObj,
        color: object.material.color.clone(),
      };

      await this.setHighlightLine(rayObj); // 设置所选mesh line高亮
      this.highlightInstanceMesh(
        object,
        instanceId,
        new THREE.Color('rgb(3,213,173)')
      ); // 设置所选mesh line高亮

      this.meshClipping && this.meshClippingStart();

      if (isLookat) {
        this.lookAtMesh(rayObj, isLookat);
      } else {
        this.animateControls(rayObj.point);
      }
    },
    /**
     * @description: 高亮 instancenMesh
     */
    highlightInstanceMesh(mesh, index, color = new THREE.Color()) {
      if (index !== undefined) {
        mesh.setColorAt(index, color);
        mesh.instanceColor.needsUpdate = true;
      } else {
        mesh.material.color.copy(color);
      }
    },
    /**
     * @description: 获取 matrix
     */
    getMatrix(mesh) {
      let num = 0;
      mesh.matrixWorld.elements.forEach((m) => {
        num += m;
      });
      return num !== 4 ? mesh.matrixWorld : mesh.parent.matrix;
    },
    /**
     * @description: 删除手动添加的instancenMesh
     */
    removeLookup() {
      scene.traverse((item, index) => {
        if (item.isGroup) {
          for (let i = item.children.length - 1; i >= 0; i--) {
            const child = item.children[i];
            if (child.name === 'lookup') {
              child.geometry.dispose();
              child.material.dispose();
              !!child.clear && child.clear();
              item.remove(child);
              item.children.splice(i, 1);
            }
          }
        }
      });
    },
    initPlanes() {
      planes = [];
      planes = [
        new THREE.Plane(new THREE.Vector3(0, -1, 0), boxMax.y), //上
        new THREE.Plane(new THREE.Vector3(0, 1, 0), -boxMin.y), // 下
        new THREE.Plane(new THREE.Vector3(1, 0, 0), -boxMin.x), // 左
        new THREE.Plane(new THREE.Vector3(-1, 0, 0), boxMax.x), // 右
        new THREE.Plane(new THREE.Vector3(0, 0, -1), boxMax.z), // 前
        new THREE.Plane(new THREE.Vector3(0, 0, 1), -boxMin.z), // 后
      ];
    },
    updatePlanes() {
      planes[0].constant = boxMax.y;
      planes[1].constant = -boxMin.y;
      planes[2].constant = -boxMin.x;
      planes[3].constant = boxMax.x;
      planes[4].constant = boxMax.z;
      planes[5].constant = -boxMin.z;
    },
    initOrUpdateVertices() {
      // 初始化、更新剖面框的8个顶点
      vertices = [];
      for (let i = 0; i < 8; i++) {
        vertices[i] = new THREE.Vector3();
      }
      vertices[0].set(boxMin.x, boxMax.y, boxMin.z); // 顶部4个顶点
      vertices[1].set(boxMax.x, boxMax.y, boxMin.z);
      vertices[2].set(boxMax.x, boxMax.y, boxMax.z);
      vertices[3].set(boxMin.x, boxMax.y, boxMax.z);
      vertices[4].set(boxMin.x, boxMin.y, boxMin.z); // 底部4个顶点
      vertices[5].set(boxMax.x, boxMin.y, boxMin.z);
      vertices[6].set(boxMax.x, boxMin.y, boxMax.z);
      vertices[7].set(boxMin.x, boxMin.y, boxMax.z);
    },
    initOrUpdateFaces() {
      const v = vertices;
      if (!faces || faces.length === 0) {
        // 创建面
        faces = [];
        faces.push(
          this.createBoxFace('yUp', [v[0], v[1], v[2], v[3]]), // up
          this.createBoxFace('yDown', [v[4], v[7], v[6], v[5]]), // down
          this.createBoxFace('xLeft', [v[0], v[3], v[7], v[4]]), // left
          this.createBoxFace('xRight', [v[1], v[5], v[6], v[2]]), // right
          this.createBoxFace('zFront', [v[2], v[6], v[7], v[3]]), // front
          this.createBoxFace('zBack', [v[0], v[4], v[5], v[1]]) // back
        );
        boxGroup.add(...faces);
        faces.forEach((face) => {
          boxGroup.add(face.backFace);
        });
      } else {
        const f = faces;
        f[0].setFromPoints([v[0], v[1], v[2], v[3]]);
        f[1].setFromPoints([v[4], v[7], v[6], v[5]]);
        f[2].setFromPoints([v[0], v[3], v[7], v[4]]);
        f[3].setFromPoints([v[1], v[5], v[6], v[2]]);
        f[4].setFromPoints([v[2], v[6], v[7], v[3]]);
        f[5].setFromPoints([v[0], v[4], v[5], v[1]]);
      }
    },
    initOrUpdateLines() {
      const v = vertices;
      if (!lines || lines.length === 0) {
        // 12 条线
        lines = [];
        const f = faces;
        if (!f) {
          throw Error('Need to init Face first!');
        }
        lines.push(
          this.createBoxLine([v[0], v[1]], [f[0], f[5]]),
          this.createBoxLine([v[1], v[2]], [f[0], f[3]]),
          this.createBoxLine([v[2], v[3]], [f[0], f[4]]),
          this.createBoxLine([v[3], v[0]], [f[0], f[2]]),
          this.createBoxLine([v[4], v[5]], [f[1], f[5]]),
          this.createBoxLine([v[5], v[6]], [f[1], f[3]]),
          this.createBoxLine([v[6], v[7]], [f[1], f[4]]),
          this.createBoxLine([v[7], v[4]], [f[1], f[2]]),
          this.createBoxLine([v[0], v[4]], [f[2], f[5]]),
          this.createBoxLine([v[1], v[5]], [f[3], f[5]]),
          this.createBoxLine([v[2], v[6]], [f[3], f[4]]),
          this.createBoxLine([v[3], v[7]], [f[2], f[4]])
        );
        boxGroup.add(...lines);
      } else {
        let i = 0;
        lines[i++].setFromPoints([v[0], v[1]]);
        lines[i++].setFromPoints([v[1], v[2]]);
        lines[i++].setFromPoints([v[2], v[3]]);
        lines[i++].setFromPoints([v[3], v[0]]);
        lines[i++].setFromPoints([v[4], v[5]]);
        lines[i++].setFromPoints([v[5], v[6]]);
        lines[i++].setFromPoints([v[6], v[7]]);
        lines[i++].setFromPoints([v[7], v[4]]);
        lines[i++].setFromPoints([v[0], v[4]]);
        lines[i++].setFromPoints([v[1], v[5]]);
        lines[i++].setFromPoints([v[2], v[6]]);
        lines[i++].setFromPoints([v[3], v[7]]);
      }
    },
    meshClippingStart() {
      this.el.removeEventListener('click', this.onMaterialClick);
      this.enableClipping(true);
      if (this.isMobile) {
        this.handlSehow = false;
        this.mobileClipping = true;
      } else {
        this.clippingShow = true;
      }
    },
    enableClipping(isHiglightClipping) {
      if (this.clippingShow) return false;
      // camera.position.set(cameraSize / 0.6, cameraSize / 0.6, cameraSize / 0.6);

      renderer.localClippingEnabled = true;
      boxGroup = new THREE.Group({ name: 'boxGroup' });
      const box = helperBox;
      // const scalarSize = (box.max.x + box.max.y + box.max.z) / 10;
      // box.expandByScalar(scalarSize); // 设置缩放比例
      groupBox = deepClone(box);

      this.mobileClippingMin = { ...groupBox.min };
      this.mobileClippingMax = { ...groupBox.max };
      this.mobileClippingValueX = [groupBox.min.x, groupBox.max.x];
      this.mobileClippingValueY = [groupBox.min.y, groupBox.max.y];
      this.mobileClippingValueZ = [groupBox.min.z, groupBox.max.z];

      boxMax = box.max;
      boxMin = box.min;
      this.initPlanes(); // 初始化6个平面
      this.initSectionBox(); // 初始化模型material.clippingPlanes
      this.initOrUpdateVertices(); // 初始化8个顶点
      this.initOrUpdateFaces(); // 初始化6个面
      this.initOrUpdateLines(); // 初始化12条线
      scene.add(boxGroup);
      // this.addMouseListener();

      isHiglightClipping && this.setHighlightClipping(); // 满足扫码指定模型剖切
      this.render();
    },
    async findHighlightLine(group) {
      const search = group.children.find(
        (child) => child.name === 'highlight_line'
      );
      return search;
    },
    /**
     * @description：剖切面包围高亮模型
     */
    async setHighlightClipping() {
      camera.position.set(cameraSize / 1, cameraSize / 1, cameraSize / 1);
      const search = await this.findHighlightLine(group);
      let searchBox = new THREE.Box3().setFromObject(search);

      if (!this.isMobile) {
        const scalarSize =
          (searchBox.max.x + searchBox.max.y + searchBox.max.z) / 10;
        searchBox.expandByScalar(scalarSize);
        let xLeftValue = Math.floor((searchBox.min.x / groupBox.min.x) * 1000);
        let rightNum = Math.floor((searchBox.max.x / groupBox.max.x) * 1000);
        this.clippingValueX = [-xLeftValue, rightNum];

        let ydownValue = Math.floor((searchBox.min.y / groupBox.min.y) * 1000);
        let yUpValue = Math.floor((searchBox.max.y / groupBox.max.y) * 1000);
        this.clippingValueY = [-ydownValue, yUpValue];

        let zBackValue = Math.floor((searchBox.min.z / groupBox.min.z) * 1000);
        let zFrontValue = Math.floor((searchBox.max.z / groupBox.max.z) * 1000);
        this.clippingValueZ = [-zBackValue, zFrontValue];
      } else {
        searchBox.expandByScalar(200);
        this.mobileClippingSite = 'z';
        this.mobileClippingValueX = [searchBox.min.x, searchBox.max.x];
        this.mobileClippingValueY = [searchBox.min.y, searchBox.max.y];
        this.mobileClippingValueZ = [searchBox.min.z, searchBox.max.z];

        const center = new THREE.Vector3();
        controls.target.set(...searchBox.getCenter(center));
        controls.enablePan = false;
      }
    },
    // 创建box面
    createBoxFace(axis, vertices) {
      const geometry = new THREE.BufferGeometry();
      geometry.setFromPoints(vertices);
      geometry.setIndex([0, 3, 2, 0, 2, 1]);
      geometry.computeVertexNormals();
      const material = new THREE.MeshBasicMaterial({
        colorWrite: false,
        depthWrite: false,
      });
      const mesh = new THREE.Mesh(geometry, material);
      mesh.axis = axis;
      mesh.name = axis;
      mesh.lines = [];
      const backMaterial = new THREE.MeshBasicMaterial({
        color: 0x34ac54,
        transparent: true,
        opacity: 0,
        side: THREE.BackSide,
      });
      mesh.backFace = new THREE.Mesh(geometry, backMaterial);
      mesh.setActive = (isActive) => {
        mesh.lines.forEach((line) => {
          line.setActive(isActive);
        });
      };
      mesh.setFromPoints = (vertices) => {
        geometry.setFromPoints(vertices);
      };
      return mesh;
    },
    // 创建box线条
    createBoxLine(vertices, faces) {
      const geometry = new THREE.BufferGeometry();
      geometry.setFromPoints(vertices);
      const normalMaterial = new THREE.LineBasicMaterial({ color: 0x795548 });
      const activeMaterial = new THREE.LineBasicMaterial({ color: 0x4e342e });
      const line = new THREE.LineSegments(geometry, normalMaterial);
      line.setActive = (isActive) => {
        line.material = isActive ? activeMaterial : normalMaterial;
        this.render();
      };
      line.setFromPoints = (vertices) => {
        geometry.setFromPoints(vertices);
      };
      faces.forEach((face) => face.lines.push(line));
      return line;
    },
    addMouseListener() {
      window.addEventListener('pointermove', this.onMouseMove);
      window.addEventListener('pointerdown', this.onMouseDown);
    },
    removeMouseListener() {
      window.removeEventListener('pointermove', this.onMouseMove);
      window.removeEventListener('pointerdown', this.onMouseDown);
    },
    onMouseMove(event) {
      this.updateMouseAndRay(event);
      const intersects = raycaster.intersectObjects(faces);
      if (intersects.length) {
        this.el.style.cursor = 'pointer';
        const face = intersects[0].object;
        if (face !== activeFace) {
          if (activeFace) {
            activeFace.setActive(false);
          }
          face.setActive(true);
          activeFace = face;
        }
      } else {
        if (activeFace) {
          activeFace.setActive(false);
          activeFace = null;
          this.el.style.cursor = 'auto';
        }
      }

      this.render();
    },
    onMouseDown(event) {
      const isLeftButton = event.button === 0; // 0: left button, 1: middle button, 2: right button
      if (activeFace && isLeftButton) {
        this.updateMouseAndRay(event);
        const intersects = raycaster.intersectObjects(faces);
        if (intersects.length) {
          const face = intersects[0].object;
          const axis = face.axis;
          const point = intersects[0].point;
          this.dragStart(axis, point);
        }
      }
      this.render();
    },
    updateMouseAndRay(event) {
      const mousePosition = new THREE.Vector2();
      mousePosition.setX((event.clientX / window.innerWidth) * 2 - 1);
      mousePosition.setY(-(event.clientY / window.innerHeight) * 2 + 1);
      raycaster.setFromCamera(mousePosition, camera);
    },
    dragStart(axis = '', point = new THREE.Vector3()) {
      drag.axis = axis;
      drag.point = point;
      this.dragInitGround();
      controls.enablePan = false;
      controls.enableZoom = false;
      controls.enableRotate = false;
      this.el.style.cursor = 'move';
      window.removeEventListener('pointermove', this.onMouseMove);
      window.addEventListener('pointermove', this.dragMousemove);
      window.addEventListener('pointerup', this.dragMouseup);
    },
    dragMousemove(event) {
      this.updateMouseAndRay(event);
      const intersects = raycaster.intersectObject(drag.ground); // 鼠标与拖动地面的相交情况
      if (intersects.length) {
        this.dragUpdateSectionBox(intersects[0].point);
      }
      this.render();
    },
    dragMouseup(event) {
      this.dragEnd();
    },
    dragInitGround() {
      const normals = {
        xLeft: new THREE.Vector3(-1, 0, 0),
        xRight: new THREE.Vector3(1, 0, 0),
        yDown: new THREE.Vector3(0, -1, 0),
        yUp: new THREE.Vector3(0, 1, 0),
        zBack: new THREE.Vector3(0, 0, -1),
        zFront: new THREE.Vector3(0, 0, 1),
      };
      if (['xLeft', 'xRight'].includes(drag.axis)) {
        drag.point.setX(0);
      } else if (['yDown', 'yUp'].includes(drag.axis)) {
        drag.point.setY(0);
      } else if (['zBack', 'zFront'].includes(drag.axis)) {
        drag.point.setZ(0);
      }
      drag.ground.position.copy(drag.point);
      const newNormal = camera.position
        .clone()
        .sub(camera.position.clone().projectOnVector(normals[drag.axis]))
        .add(drag.point);
      drag.ground.lookAt(newNormal);
      scene.add(drag.ground);
    },
    dragUpdateSectionBox(point) {
      const clippingValueX = this.clippingValueX;
      const clippingValueY = this.clippingValueY;
      const clippingValueZ = this.clippingValueZ;
      const minSize = 1;
      switch (drag.axis) {
        case 'yUp': // up
          boxMax.setY(Math.max(boxMin.y + minSize, point.y));
          let yUpValue = Math.floor((boxMax.y / groupBox.max.y) * 1000);
          this.clippingValueY = [clippingValueY[0], yUpValue];
          break;
        case 'yDown': // down
          boxMin.setY(Math.min(boxMax.y - minSize, point.y));
          let ydownValue = Math.floor((boxMin.y / groupBox.min.y) * 1000);
          this.clippingValueY = [-ydownValue, clippingValueY[1]];
          break;
        case 'xLeft': // left
          boxMin.setX(Math.min(boxMax.x - minSize, point.x));
          let xLeftValue = Math.floor((boxMin.x / groupBox.min.x) * 1000);
          this.clippingValueX = [-xLeftValue, clippingValueX[1]];
          break;
        case 'xRight': // right
          boxMax.setX(Math.max(boxMin.x + minSize, point.x));
          let xRightValue = Math.floor((boxMax.x / groupBox.max.x) * 1000);
          this.clippingValueX = [clippingValueX[0], xRightValue];
          break;
        case 'zFront': // front
          boxMax.setZ(Math.max(boxMin.z + minSize, point.z));
          let zFrontValue = Math.floor((boxMax.z / groupBox.max.z) * 1000);
          this.clippingValueZ = [clippingValueZ[0], zFrontValue];
          break;
        case 'zBack': // back
          boxMin.setZ(Math.min(boxMax.z - minSize, point.z));
          let zBackValue = Math.floor((boxMin.z / groupBox.min.z) * 1000);
          this.clippingValueZ = [-zBackValue, clippingValueZ[1]];
          break;
      }
    },
    dragEnd() {
      scene.remove(drag.ground);
      controls.enablePan = true;
      controls.enableZoom = true;
      controls.enableRotate = true;
      window.removeEventListener('pointermove', this.dragMousemove);
      window.removeEventListener('pointerup', this.dragMouseup);
      window.addEventListener('pointermove', this.onMouseMove);
      this.render();
    },
    closeClipping() {
      this.el.addEventListener('click', this.onMaterialClick);
      this.el.addEventListener('dblclick', (event) =>
        this.onMaterialClick(event, true)
      );
      this.removeMouseListener();
      scene.remove(boxGroup);
      this.el.style.cursor = '';

      this.clearSectionBox();

      camera.position.set(cameraSize, cameraSize, cameraSize);
      controls.enablePan = true;
      this.render();
    },
    initSectionBox() {
      group.traverse((child) => {
        if (['Mesh', 'LineSegments'].includes(child.type)) {
          child.material.clippingPlanes = planes;
          child.material.clipIntersection = false;
        }
      });
    },
    clearSectionBox() {
      group.traverse((child) => {
        if (['Mesh', 'LineSegments'].includes(child.type)) {
          child.material.clippingPlanes = [];
        }
      });
      boxMax = null;
      boxMin = null;
      groupBox = null;
      boxGroup = null;
      faces = null;
      activeFace = null;
      lines = null;
      planes = null;
      vertices = null;
    },
    resetSectionBox() {
      this.yUpValue = 100;
      this.yDownValue = -100;
      this.xLeftValue = -100;
      this.xRightValue = 100;
      this.zFrontValue = 100;
      this.zBackValue = -100;
      this.clippingValueX = [-1000, 1000];
      this.clippingValueY = [-1000, 1000];
      this.clippingValueZ = [-1000, 1000];
    },
    resetSectionBoxMobile() {
      this.mobileClippingValueX = [
        this.mobileClippingMin.x,
        this.mobileClippingMax.x,
      ];
      this.mobileClippingValueY = [
        this.mobileClippingMin.y,
        this.mobileClippingMax.y,
      ];
      this.mobileClippingValueZ = [
        this.mobileClippingMin.z,
        this.mobileClippingMax.z,
      ];
    },
    clippingInput(coordinate) {
      const coordinateObj = {
        x: [this.xLeftValue, this.xRightValue],
        y: [this.yDownValue, this.yUpValue],
        z: [this.zBackValue, this.zFrontValue],
      };
      const val = coordinateObj[coordinate];
      this.clippingSlider(val, coordinate);
      this[`clippingValue${coordinate.toUpperCase()}`] = [
        val[0] * 10,
        val[1] * 10,
      ];
    },
    clippingSlider(val, coordinate) {
      const val0 = val[0] / 10;
      const val1 = val[1] / 10;
      const minSize = 1;
      switch (coordinate) {
        case 'x':
          this.xLeftValue = val0;
          this.xRightValue = val1;

          let leftNum =
            val[0] > 0
              ? groupBox.max.x * (val[0] / 1000)
              : -(groupBox.min.x * (val[0] / 1000));
          let rightNum =
            val[1] > 0
              ? groupBox.max.x * (val[1] / 1000)
              : -(groupBox.min.x * (val[1] / 1000));

          boxMin.setX(Math.min(boxMax.x - minSize, leftNum));
          boxMax.setX(Math.max(boxMin.x + minSize, rightNum));
          break;
        case 'y':
          this.yDownValue = val0;
          this.yUpValue = val1;

          let downNum =
            val[0] > 0
              ? groupBox.max.y * (val[0] / 1000)
              : -(groupBox.min.y * (val[0] / 1000));
          let upNum =
            val[1] > 0
              ? groupBox.max.y * (val[1] / 1000)
              : -(groupBox.min.y * (val[1] / 1000));

          boxMin.setY(Math.min(boxMax.y - minSize, downNum));
          boxMax.setY(Math.max(boxMin.y + minSize, upNum));
          break;
        case 'z':
          this.zBackValue = val0;
          this.zFrontValue = val1;

          let backNum =
            val[0] > 0
              ? groupBox.max.z * (val[0] / 1000)
              : -(groupBox.min.z * (val[0] / 1000));
          let frontNum =
            val[1] > 0
              ? groupBox.max.z * (val[1] / 1000)
              : -(groupBox.min.z * (val[1] / 1000));

          boxMin.setZ(Math.min(boxMax.z - minSize, backNum));
          boxMax.setZ(Math.max(boxMin.z + minSize, frontNum));
          break;
      }

      this.updatePlanes();
      this.initOrUpdateVertices();
      this.initOrUpdateFaces();
      this.initOrUpdateLines();
      this.render();
    },
    mobileClippingInput(val, site) {
      if (!boxMin) return;
      switch (site) {
        case 'x':
          boxMin.setX(Math.min(boxMax.x - 1, val[0]));
          boxMax.setX(Math.max(boxMin.x + 1, val[1]));
          break;
        case 'y':
          boxMin.setY(Math.min(boxMax.y - 1, val[0]));
          boxMax.setY(Math.max(boxMin.y + 1, val[1]));
          break;
        case 'z':
          boxMin.setZ(Math.min(boxMax.z - 1, val[0]));
          boxMax.setZ(Math.max(boxMin.z + 1, val[1]));
          break;
      }
      this.updatePlanes();
      this.initOrUpdateVertices();
      this.initOrUpdateFaces();
      this.initOrUpdateLines();
      this.render();
    },
    mobileClippingSiteChange() {
      this.mobileClippingInput(this.mobileClippingMin);
      const site = this.mobileClippingSite;
      this.mobileClippingSite = site === 'x' ? 'y' : site === 'y' ? 'z' : 'x';
    },
    animateControls(newTargetPoint = new THREE.Vector3(0, 0, 0)) {
      let tween = new TWEEN.Tween(controls.target);
      tween.to(newTargetPoint, 1000);
      tween.onUpdate((object) => {
        this.requestRenderIfNotRequested();
        controls.target.set(...object);
      });
      tween.easing(TWEEN.Easing.Cubic.InOut);
      tween.start();
      this.requestRenderIfNotRequested();
    },
    animateCamera(current1, target1, current2, target2) {
      var tween = new TWEEN.Tween({
        x1: current1.x, // 相机当前位置x
        y1: current1.y, // 相机当前位置y
        z1: current1.z, // 相机当前位置z
        x2: current2.x, // 控制当前的中心点x
        y2: current2.y, // 控制当前的中心点y
        z2: current2.z, // 控制当前的中心点z
      });
      tween.to(
        {
          x1: target1.x, // 新的相机位置x
          y1: target1.y, // 新的相机位置y
          z1: target1.z, // 新的相机位置z
          x2: target2.x, // 新的控制中心点位置x
          y2: target2.y, // 新的控制中心点位置x
          z2: target2.z, // 新的控制中心点位置x
        },
        1000
      );
      tween.onUpdate((object) => {
        this.requestRenderIfNotRequested();
        camera.position.x = object.x1;
        camera.position.y = object.y1;
        camera.position.z = object.z1;
        controls.target.x = object.x2;
        controls.target.y = object.y2;
        controls.target.z = object.z2;
      });
      tween.easing(TWEEN.Easing.Cubic.InOut);
      tween.start();

      this.render();
    },
    getUniqueId(mesh) {
      const { userData } = mesh;
      if (mesh.userData.UniqueId) {
        return { ...userData };
      } else {
        return this.getUniqueId(mesh.parent);
      }
    },
    async clippingPanelClose() {
      this.handleShow = true;
      if (this.activeHandle === 'meshClipping') {
        this.closeClipping();
        if (this.isMobile) {
          this.mobileClipping = false;
        } else {
          this.clippingShow = false;
        }
      } else {
        this.handleChild = '';
        this.handleOperate('outclipping');
      }
    },
    async showMeshClippingHandler() {
      this.handleShow = true;
      await this.resetSectionBoxMobile();
      this.meshClipping = false;
      this.showMeshClipping = false;
      this.activeHandle = null;

      if (this.isMobile) {
        await this.resetSectionBoxMobile();
        this.mobileClipping = false;
      } else {
        await this.resetSectionBox();
        this.clippingShow = false;
      }
      this.closeClipping();
      this.handleChild = '';
    },
    releaseRender(renderer, scene) {
      let clearScene = function (scene) {
        let arr = scene.children.filter((x) => x);
        arr.forEach((item) => {
          if (item.children.length) {
            clearScene(item);
          } else {
            if (item.type === 'Mesh') {
              item.geometry.dispose();
              item.material.dispose();
              !!item.clear && item.clear();
            }
          }
        });
        !!scene.clear && scene.clear(renderer);
        arr = null;
      };
      try {
        clearScene(scene);
      } catch (e) {}
      try {
        renderer.renderLists.dispose();
        renderer.dispose();
        renderer.forceContextLoss();
        renderer.domElement = null;
        renderer.content = null;
        renderer = null;
      } catch (e) {}
      if (!!window.requestAnimationId) {
        cancelAnimationFrame(window.requestAnimationId);
      }
      THREE.Cache.clear();
    },
    removeURLParameter(delKey) {
      const url = window.location.href;
      const paramsStr = url.split('?')[1];
      if (paramsStr) {
        const paramsArr = paramsStr.split('&');
        let newParams = '';
        paramsArr.forEach((item) => {
          const key = item.split('=')[0];
          if (key !== delKey) {
            newParams += item + '&';
          }
        });
        newParams = newParams.substring(0, newParams.length - 1);
        return url.split('?')[0] + '?' + newParams;
      }
      return url;
    },
    handleAllShowCancel() {
      this.showAllConfirm = false;
    },
    handleAllShowConfirm() {
      const newUrl = this.removeURLParameter('code');
      location.replace(newUrl);
      location.reload();
    },
    exportJson(jsonString) {
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
  },
  destroyed() {
    this.releaseRender(renderer, scene);
  },
};
</script>

<style lang="scss">
@import 'bimViewer.scss';

.container {
  position: relative;
}

.watermark-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  background-repeat: repeat;
}
</style>
